export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 200 CARDS',
    parallels: [{id:'rainbow-refractor',name:'Rainbow Refractor',print_run:null,color:'#e7c3e2'},{id:'prism-refractor',name:'Prism Refractor',print_run:null,color:'#d4d1e8'},{id:'black-and-white-shimmer-refractor',name:'Black & White Shimmer Refractor',print_run:null,color:'#e8e8ec'},{id:'raywave-refractor',name:'RayWave Refractor',print_run:null,color:'#6cef4d'},{id:'blue-pulsar-refractor',name:'Blue Pulsar Refractor',print_run:null,color:'#5f8dff'},{id:'purple-pulsar-refractor',name:'Purple Pulsar Refractor',print_run:null,color:'#cb7dff'},{id:'kamino-purple-refractor',name:'Kamino Purple Refractor',print_run:199,color:'#bb8ce4'},{id:'skywalker-blue-refractor',name:'Skywalker Blue Refractor',print_run:150,color:'#7ba2ff'},{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'gold-mini-diamonds-refractor',name:'Gold Mini Diamonds Refractor',print_run:50,color:'#f3d985'},{id:'orange-pulsar-refractor',name:'Orange Pulsar Refractor',print_run:25,color:'#ff9d52'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'rebel-orange-wave-refractor',name:'Rebel Orange Wave Refractor',print_run:25,color:'#ffb072'},{id:'black-pulsar-refractor',name:'Black Pulsar Refractor',print_run:10,color:'#a8a8b4'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'mustafar-black-lava-refractor',name:'Mustafar Black Lava Refractor',print_run:10,color:'#c98f82'},{id:'red-pulsar-refractor',name:'Red Pulsar Refractor',print_run:5,color:'#ff806b'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'dathomir-red-wave-refractor',name:'Dathomir Red Wave Refractor',print_run:5,color:'#ff9090'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'1', name:'Admiral Ackbar', artist:null},
      {n:'2', name:'Ahsoka Tano', artist:null},
      {n:'3', name:'Anakin Skywalker', artist:null},
      {n:'4', name:'Arvel Skeen', artist:null},
      {n:'5', name:'Baylan Skoll', artist:null},
      {n:'6', name:'Bazil', artist:null},
      {n:'7', name:'Beru Lars', artist:null},
      {n:'8', name:'Birnok', artist:null},
      {n:'9', name:'Bix Caleen', artist:null},
      {n:'10', name:'Bo-Katan Kryze', artist:null},
      {n:'11', name:'Boba Fett', artist:null},
      {n:'12', name:'Bodhi Rook', artist:null},
      {n:'13', name:'C-3PO', artist:null},
      {n:'14', name:'C1-D1', artist:null},
      {n:'15', name:'Captain Blex', artist:null},
      {n:'16', name:'Captain Elk', artist:null},
      {n:'17', name:'Captain Girard', artist:null},
      {n:'18', name:'Captain Hayle', artist:null},
      {n:'19', name:'Captain Phasma', artist:null},
      {n:'20', name:'Captain Porter', artist:null},
      {n:'21', name:'Captain Silvo', artist:null},
      {n:'22', name:'Cassian Andor', artist:null},
      {n:'23', name:'Chewbacca', artist:null},
      {n:'24', name:'Chirrut Îmwe', artist:null},
      {n:'25', name:'Chopper', artist:null},
      {n:'26', name:'Clone Captain Rex', artist:null},
      {n:'27', name:'Count Dooku', artist:null},
      {n:'28', name:'Darth Maul', artist:null},
      {n:'29', name:'Darth Vader', artist:null},
      {n:'30', name:'Dedra Meero', artist:null},
      {n:'31', name:'Dengar', artist:null},
      {n:'32', name:'Dinghy Driver', artist:null},
      {n:'33', name:'DJ', artist:null},
      {n:'34', name:'Dr. Gorst', artist:null},
      {n:'35', name:'Dryden Vos', artist:null},
      {n:'36', name:'Eedy Karn', artist:null},
      {n:'37', name:'Elder Naasa', artist:null},
      {n:'38', name:'Emperor Palpatine', artist:null},
      {n:'39', name:'Ezra Bridger', artist:null},
      {n:'40', name:'Fara', artist:null},
      {n:'41', name:'Fennec Shand', artist:null},
      {n:'42', name:'Fern', artist:null},
      {n:'43', name:'Fifth Brother Inquisitor', artist:null},
      {n:'44', name:'Fillik', artist:null},
      {n:'45', name:'Finn', artist:null},
      {n:'46', name:'First Officer Jensen Corbyt', artist:null},
      {n:'47', name:'Galen Erso', artist:null},
      {n:'48', name:'Garsa Fwip', artist:null},
      {n:'49', name:'General Grievous', artist:null},
      {n:'50', name:'General Hux', artist:null},
      {n:'51', name:'General Pryde', artist:null},
      {n:'52', name:'Grand Admiral Thrawn', artist:null},
      {n:'53', name:'Grand Moff Tarkin', artist:null},
      {n:'54', name:'Greedo', artist:null},
      {n:'55', name:'Greef Karga', artist:null},
      {n:'56', name:'Grogu', artist:null},
      {n:'57', name:'Gunter', artist:null},
      {n:'58', name:'Han Solo', artist:null},
      {n:'59', name:'Hera Syndulla', artist:null},
      {n:'60', name:'IG-11', artist:null},
      {n:'61', name:'Indara', artist:null},
      {n:'62', name:'Jabba The Hutt', artist:null},
      {n:'63', name:'Jar Jar Binks', artist:null},
      {n:'64', name:'Jecki Lon', artist:null},
      {n:'65', name:'Jod Na Nawood', artist:null},
      {n:'66', name:'Jyn Erso', artist:null},
      {n:'67', name:'K-2SO', artist:null},
      {n:'68', name:'Karis Nemik', artist:null},
      {n:'69', name:'Kassa', artist:null},
      {n:'70', name:'Kawlan Roken', artist:null},
      {n:'71', name:'Kaydel Connix', artist:null},
      {n:'72', name:'Kelleran Beq', artist:null},
      {n:'73', name:'Kelnacca', artist:null},
      {n:'74', name:'Kh\'ymm', artist:null},
      {n:'75', name:'Klothow', artist:null},
      {n:'76', name:'Koska Reeves', artist:null},
      {n:'77', name:'L3-37', artist:null},
      {n:'78', name:'Lando Calrissian', artist:null},
      {n:'79', name:'Lando Calrissian', artist:null},
      {n:'80', name:'Leia Organa', artist:null},
      {n:'81', name:'Logray', artist:null},
      {n:'82', name:'Lor San Tekka', artist:null},
      {n:'83', name:'Luke Skywalker', artist:null},
      {n:'84', name:'Luthen Rael', artist:null},
      {n:'85', name:'Mace Windu', artist:null},
      {n:'86', name:'Mae Aniseya', artist:null},
      {n:'87', name:'Maree', artist:null},
      {n:'88', name:'Master Codebreaker', artist:null},
      {n:'89', name:'Max Rebo', artist:null},
      {n:'90', name:'Maz Kanata', artist:null},
      {n:'91', name:'Moff Gideon', artist:null},
      {n:'92', name:'Mog Adana', artist:null},
      {n:'93', name:'Mon Mothma', artist:null},
      {n:'94', name:'Mother Aniseya', artist:null},
      {n:'95', name:'Mother Koril', artist:null},
      {n:'96', name:'Nol', artist:null},
      {n:'97', name:'Pokkit', artist:null},
      {n:'98', name:'Skull Ridge Mountain Hotelier', artist:null},
      {n:'99', name:'SM-33', artist:null},
      {n:'100', name:'Trash crab', artist:null},
      {n:'101', name:'2-1B Droid', artist:null},
      {n:'102', name:'Adi Gallia', artist:null},
      {n:'103', name:'Aemon Gremm', artist:null},
      {n:'104', name:'Bazine Netal', artist:null},
      {n:'105', name:'BB-9E', artist:null},
      {n:'106', name:'Beaumont Kin', artist:null},
      {n:'107', name:'Benjar Pranic', artist:null},
      {n:'108', name:'Bossk', artist:null},
      {n:'109', name:'Brasso', artist:null},
      {n:'110', name:'Cabuck', artist:null},
      {n:'111', name:'Chancellor Drellik', artist:null},
      {n:'112', name:'Chief Chirpa', artist:null},
      {n:'113', name:'Darth Bane', artist:null},
      {n:'114', name:'Dokk Strassi', artist:null},
      {n:'115', name:'Enfys Nest', artist:null},
      {n:'116', name:'Figrin D\'an', artist:null},
      {n:'117', name:'Fuzzball', artist:null},
      {n:'118', name:'Fyrnock', artist:null},
      {n:'119', name:'General Pong Krell', artist:null},
      {n:'120', name:'General Strix', artist:null},
      {n:'121', name:'Glerb', artist:null},
      {n:'122', name:'Hayna', artist:null},
      {n:'123', name:'Hondo Ohnaka', artist:null},
      {n:'124', name:'IG-88', artist:null},
      {n:'125', name:'Jawa', artist:null},
      {n:'126', name:'Jess Pava', artist:null},
      {n:'127', name:'Kayo Organa', artist:null},
      {n:'128', name:'KB', artist:null},
      {n:'129', name:'Kona', artist:null},
      {n:'130', name:'Kragan Gorr', artist:null},
      {n:'131', name:'Lobot', artist:null},
      {n:'132', name:'Lortha Peel', artist:null},
      {n:'133', name:'Mas Amedda', artist:null},
      {n:'134', name:'Mayor Mok Shaiz', artist:null},
      {n:'135', name:'Melna', artist:null},
      {n:'136', name:'Mother Talzin', artist:null},
      {n:'137', name:'Neel', artist:null},
      {n:'138', name:'Obi-Wan Kenobi', artist:null},
      {n:'139', name:'Obi-Wan Kenobi', artist:null},
      {n:'140', name:'Osha Aniseya', artist:null},
      {n:'141', name:'Padmé Amidala', artist:null},
      {n:'142', name:'Pegla', artist:null},
      {n:'143', name:'Pip', artist:null},
      {n:'144', name:'Pirate Captain Brutus', artist:null},
      {n:'145', name:'Poe Dameron', artist:null},
      {n:'146', name:'Poggle the Lesser', artist:null},
      {n:'147', name:'Porg', artist:null},
      {n:'148', name:'Professor Huyang', artist:null},
      {n:'149', name:'Pyke Boss', artist:null},
      {n:'150', name:'Qi\'ra', artist:null},
      {n:'151', name:'Queen Apailana', artist:null},
      {n:'152', name:'Qui-Gon Jinn', artist:null},
      {n:'153', name:'R2-D2', artist:null},
      {n:'154', name:'Ragnar Vizsla', artist:null},
      {n:'155', name:'Rey', artist:null},
      {n:'156', name:'Rio Durant', artist:null},
      {n:'157', name:'Roona', artist:null},
      {n:'158', name:'Rose Tico', artist:null},
      {n:'159', name:'Sabé', artist:null},
      {n:'160', name:'Sabine Wren', artist:null},
      {n:'161', name:'Safety Droid', artist:null},
      {n:'162', name:'Savage Opress', artist:null},
      {n:'163', name:'Senator Rayencourt', artist:null},
      {n:'164', name:'Sergeant Linus Mosk', artist:null},
      {n:'165', name:'Shaak Ti', artist:null},
      {n:'166', name:'Shin Hati', artist:null},
      {n:'167', name:'Skura', artist:null},
      {n:'168', name:'Slowen Lo', artist:null},
      {n:'169', name:'Sly Moore', artist:null},
      {n:'170', name:'Snowball', artist:null},
      {n:'171', name:'Sol', artist:null},
      {n:'172', name:'Sully Stark', artist:null},
      {n:'173', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'174', name:'Supreme Leader Snoke', artist:null},
      {n:'175', name:'Tasi Lowa', artist:null},
      {n:'176', name:'Teacher Droid', artist:null},
      {n:'177', name:'Tera Sinube', artist:null},
      {n:'178', name:'The Armorer', artist:null},
      {n:'179', name:'The Client', artist:null},
      {n:'180', name:'The Grand Inquisitor', artist:null},
      {n:'181', name:'The Mandalorian', artist:null},
      {n:'182', name:'The Stranger', artist:null},
      {n:'183', name:'Tion Medon', artist:null},
      {n:'184', name:'Tobias Beckett', artist:null},
      {n:'185', name:'Torbin', artist:null},
      {n:'186', name:'Unkar Plutt', artist:null},
      {n:'187', name:'Val', artist:null},
      {n:'188', name:'Vernestra Rwoh', artist:null},
      {n:'189', name:'Vetch', artist:null},
      {n:'190', name:'Watto', artist:null},
      {n:'191', name:'Wendle', artist:null},
      {n:'192', name:'Wilmon Paak', artist:null},
      {n:'193', name:'Wim', artist:null},
      {n:'194', name:'Wullf Yularen', artist:null},
      {n:'195', name:'Xanwan', artist:null},
      {n:'196', name:'Yarael Poof', artist:null},
      {n:'197', name:'Yoda', artist:null},
      {n:'198', name:'Yord Fandar', artist:null},
      {n:'199', name:'Zam Wesell', artist:null},
      {n:'200', name:'Zorii Bliss', artist:null},
    ]
  },
  {
    id: 'printing-plate-book-card', type: 'insert', title: 'PRINTING PLATE BOOK CARD — 200 CARDS',
    parallels: [],
    cards: [
      {n:'BC-1', name:'Admiral Ackbar', artist:null},
      {n:'BC-2', name:'Ahsoka Tano', artist:null},
      {n:'BC-3', name:'Anakin Skywalker', artist:null},
      {n:'BC-4', name:'Arvel Skeen', artist:null},
      {n:'BC-5', name:'Baylan Skoll', artist:null},
      {n:'BC-6', name:'Bazil', artist:null},
      {n:'BC-7', name:'Beru Lars', artist:null},
      {n:'BC-8', name:'Birnok', artist:null},
      {n:'BC-9', name:'Bix Caleen', artist:null},
      {n:'BC-10', name:'Bo-Katan Kryze', artist:null},
      {n:'BC-11', name:'Boba Fett', artist:null},
      {n:'BC-12', name:'Bodhi Rook', artist:null},
      {n:'BC-13', name:'C-3PO', artist:null},
      {n:'BC-14', name:'C1-D1', artist:null},
      {n:'BC-15', name:'Captain Blex', artist:null},
      {n:'BC-16', name:'Captain Elk', artist:null},
      {n:'BC-17', name:'Captain Girard', artist:null},
      {n:'BC-18', name:'Captain Hayle', artist:null},
      {n:'BC-19', name:'Captain Phasma', artist:null},
      {n:'BC-20', name:'Captain Porter', artist:null},
      {n:'BC-21', name:'Captain Silvo', artist:null},
      {n:'BC-22', name:'Cassian Andor', artist:null},
      {n:'BC-23', name:'Chewbacca', artist:null},
      {n:'BC-24', name:'Chirrut Îmwe', artist:null},
      {n:'BC-25', name:'Chopper', artist:null},
      {n:'BC-26', name:'Clone Captain Rex', artist:null},
      {n:'BC-27', name:'Count Dooku', artist:null},
      {n:'BC-28', name:'Darth Maul', artist:null},
      {n:'BC-29', name:'Darth Vader', artist:null},
      {n:'BC-30', name:'Dedra Meero', artist:null},
      {n:'BC-31', name:'Dengar', artist:null},
      {n:'BC-32', name:'Dinghy Driver', artist:null},
      {n:'BC-33', name:'DJ', artist:null},
      {n:'BC-34', name:'Dr. Gorst', artist:null},
      {n:'BC-35', name:'Dryden Vos', artist:null},
      {n:'BC-36', name:'Eedy Karn', artist:null},
      {n:'BC-37', name:'Elder Naasa', artist:null},
      {n:'BC-38', name:'Emperor Palpatine', artist:null},
      {n:'BC-39', name:'Ezra Bridger', artist:null},
      {n:'BC-40', name:'Fara', artist:null},
      {n:'BC-41', name:'Fennec Shand', artist:null},
      {n:'BC-42', name:'Fern', artist:null},
      {n:'BC-43', name:'Fifth Brother Inquisitor', artist:null},
      {n:'BC-44', name:'Fillik', artist:null},
      {n:'BC-45', name:'Finn', artist:null},
      {n:'BC-46', name:'First Officer Jensen Corbyt', artist:null},
      {n:'BC-47', name:'Galen Erso', artist:null},
      {n:'BC-48', name:'Garsa Fwip', artist:null},
      {n:'BC-49', name:'General Grievous', artist:null},
      {n:'BC-50', name:'General Hux', artist:null},
      {n:'BC-51', name:'General Pryde', artist:null},
      {n:'BC-52', name:'Grand Admiral Thrawn', artist:null},
      {n:'BC-53', name:'Grand Moff Tarkin', artist:null},
      {n:'BC-54', name:'Greedo', artist:null},
      {n:'BC-55', name:'Greef Karga', artist:null},
      {n:'BC-56', name:'Grogu', artist:null},
      {n:'BC-57', name:'Gunter', artist:null},
      {n:'BC-58', name:'Han Solo', artist:null},
      {n:'BC-59', name:'Hera Syndulla', artist:null},
      {n:'BC-60', name:'IG-11', artist:null},
      {n:'BC-61', name:'Indara', artist:null},
      {n:'BC-62', name:'Jabba The Hutt', artist:null},
      {n:'BC-63', name:'Jar Jar Binks', artist:null},
      {n:'BC-64', name:'Jecki Lon', artist:null},
      {n:'BC-65', name:'Jod Na Nawood', artist:null},
      {n:'BC-66', name:'Jyn Erso', artist:null},
      {n:'BC-67', name:'K-2SO', artist:null},
      {n:'BC-68', name:'Karis Nemik', artist:null},
      {n:'BC-69', name:'Kassa', artist:null},
      {n:'BC-70', name:'Kawlan Roken', artist:null},
      {n:'BC-71', name:'Kaydel Connix', artist:null},
      {n:'BC-72', name:'Kelleran Beq', artist:null},
      {n:'BC-73', name:'Kelnacca', artist:null},
      {n:'BC-74', name:'Kh\'ymm', artist:null},
      {n:'BC-75', name:'Klothow', artist:null},
      {n:'BC-76', name:'Koska Reeves', artist:null},
      {n:'BC-77', name:'L3-37', artist:null},
      {n:'BC-78', name:'Lando Calrissian', artist:null},
      {n:'BC-79', name:'Lando Calrissian', artist:null},
      {n:'BC-80', name:'Leia Organa', artist:null},
      {n:'BC-81', name:'Logray', artist:null},
      {n:'BC-82', name:'Lor San Tekka', artist:null},
      {n:'BC-83', name:'Luke Skywalker', artist:null},
      {n:'BC-84', name:'Luthen Rael', artist:null},
      {n:'BC-85', name:'Mace Windu', artist:null},
      {n:'BC-86', name:'Mae Aniseya', artist:null},
      {n:'BC-87', name:'Maree', artist:null},
      {n:'BC-88', name:'Master Codebreaker', artist:null},
      {n:'BC-89', name:'Max Rebo', artist:null},
      {n:'BC-90', name:'Maz Kanata', artist:null},
      {n:'BC-91', name:'Moff Gideon', artist:null},
      {n:'BC-92', name:'Mog Adana', artist:null},
      {n:'BC-93', name:'Mon Mothma', artist:null},
      {n:'BC-94', name:'Mother Aniseya', artist:null},
      {n:'BC-95', name:'Mother Koril', artist:null},
      {n:'BC-96', name:'Nol', artist:null},
      {n:'BC-97', name:'Pokkit', artist:null},
      {n:'BC-98', name:'Skull Ridge Mountain Hotelier', artist:null},
      {n:'BC-99', name:'SM-33', artist:null},
      {n:'BC-100', name:'Trash crab', artist:null},
      {n:'BC-101', name:'2-1B Droid', artist:null},
      {n:'BC-102', name:'Adi Gallia', artist:null},
      {n:'BC-103', name:'Aemon Gremm', artist:null},
      {n:'BC-104', name:'Bazine Netal', artist:null},
      {n:'BC-105', name:'BB-9E', artist:null},
      {n:'BC-106', name:'Beaumont Kin', artist:null},
      {n:'BC-107', name:'Benjar Pranic', artist:null},
      {n:'BC-108', name:'Bossk', artist:null},
      {n:'BC-109', name:'Brasso', artist:null},
      {n:'BC-110', name:'Cabuck', artist:null},
      {n:'BC-111', name:'Chancellor Drellik', artist:null},
      {n:'BC-112', name:'Chief Chirpa', artist:null},
      {n:'BC-113', name:'Darth Bane', artist:null},
      {n:'BC-114', name:'Dokk Strassi', artist:null},
      {n:'BC-115', name:'Enfys Nest', artist:null},
      {n:'BC-116', name:'Figrin D\'an', artist:null},
      {n:'BC-117', name:'Fuzzball', artist:null},
      {n:'BC-118', name:'Fyrnock', artist:null},
      {n:'BC-119', name:'General Pong Krell', artist:null},
      {n:'BC-120', name:'General Strix', artist:null},
      {n:'BC-121', name:'Glerb', artist:null},
      {n:'BC-122', name:'Hayna', artist:null},
      {n:'BC-123', name:'Hondo Ohnaka', artist:null},
      {n:'BC-124', name:'IG-88', artist:null},
      {n:'BC-125', name:'Jawa', artist:null},
      {n:'BC-126', name:'Jess Pava', artist:null},
      {n:'BC-127', name:'Kayo Organa', artist:null},
      {n:'BC-128', name:'KB', artist:null},
      {n:'BC-129', name:'Kona', artist:null},
      {n:'BC-130', name:'Kragan Gorr', artist:null},
      {n:'BC-131', name:'Lobot', artist:null},
      {n:'BC-132', name:'Lortha Peel', artist:null},
      {n:'BC-133', name:'Mas Amedda', artist:null},
      {n:'BC-134', name:'Mayor Mok Shaiz', artist:null},
      {n:'BC-135', name:'Melna', artist:null},
      {n:'BC-136', name:'Mother Talzin', artist:null},
      {n:'BC-137', name:'Neel', artist:null},
      {n:'BC-138', name:'Obi-Wan Kenobi', artist:null},
      {n:'BC-139', name:'Obi-Wan Kenobi', artist:null},
      {n:'BC-140', name:'Osha Aniseya', artist:null},
      {n:'BC-141', name:'Padmé Amidala', artist:null},
      {n:'BC-142', name:'Pegla', artist:null},
      {n:'BC-143', name:'Pip', artist:null},
      {n:'BC-144', name:'Pirate Captain Brutus', artist:null},
      {n:'BC-145', name:'Poe Dameron', artist:null},
      {n:'BC-146', name:'Poggle the Lesser', artist:null},
      {n:'BC-147', name:'Porg', artist:null},
      {n:'BC-148', name:'Professor Huyang', artist:null},
      {n:'BC-149', name:'Pyke Boss', artist:null},
      {n:'BC-150', name:'Qi\'ra', artist:null},
      {n:'BC-151', name:'Queen Apailana', artist:null},
      {n:'BC-152', name:'Qui-Gon Jinn', artist:null},
      {n:'BC-153', name:'R2-D2', artist:null},
      {n:'BC-154', name:'Ragnar Vizsla', artist:null},
      {n:'BC-155', name:'Rey', artist:null},
      {n:'BC-156', name:'Rio Durant', artist:null},
      {n:'BC-157', name:'Roona', artist:null},
      {n:'BC-158', name:'Rose Tico', artist:null},
      {n:'BC-159', name:'Sabé', artist:null},
      {n:'BC-160', name:'Sabine Wren', artist:null},
      {n:'BC-161', name:'Safety Droid', artist:null},
      {n:'BC-162', name:'Savage Opress', artist:null},
      {n:'BC-163', name:'Senator Rayencourt', artist:null},
      {n:'BC-164', name:'Sergeant Linus Mosk', artist:null},
      {n:'BC-165', name:'Shaak Ti', artist:null},
      {n:'BC-166', name:'Shin Hati', artist:null},
      {n:'BC-167', name:'Skura', artist:null},
      {n:'BC-168', name:'Slowen Lo', artist:null},
      {n:'BC-169', name:'Sly Moore', artist:null},
      {n:'BC-170', name:'Snowball', artist:null},
      {n:'BC-171', name:'Sol', artist:null},
      {n:'BC-172', name:'Sully Stark', artist:null},
      {n:'BC-173', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'BC-174', name:'Supreme Leader Snoke', artist:null},
      {n:'BC-175', name:'Tasi Lowa', artist:null},
      {n:'BC-176', name:'Teacher Droid', artist:null},
      {n:'BC-177', name:'Tera Sinube', artist:null},
      {n:'BC-178', name:'The Armorer', artist:null},
      {n:'BC-179', name:'The Client', artist:null},
      {n:'BC-180', name:'The Grand Inquisitor', artist:null},
      {n:'BC-181', name:'The Mandalorian', artist:null},
      {n:'BC-182', name:'The Stranger', artist:null},
      {n:'BC-183', name:'Tion Medon', artist:null},
      {n:'BC-184', name:'Tobias Beckett', artist:null},
      {n:'BC-185', name:'Torbin', artist:null},
      {n:'BC-186', name:'Unkar Plutt', artist:null},
      {n:'BC-187', name:'Val', artist:null},
      {n:'BC-188', name:'Vernestra Rwoh', artist:null},
      {n:'BC-189', name:'Vetch', artist:null},
      {n:'BC-190', name:'Watto', artist:null},
      {n:'BC-191', name:'Wendle', artist:null},
      {n:'BC-192', name:'Wilmon Paak', artist:null},
      {n:'BC-193', name:'Wim', artist:null},
      {n:'BC-194', name:'Wullf Yularen', artist:null},
      {n:'BC-195', name:'Xanwan', artist:null},
      {n:'BC-196', name:'Yarael Poof', artist:null},
      {n:'BC-197', name:'Yoda', artist:null},
      {n:'BC-198', name:'Yord Fandar', artist:null},
      {n:'BC-199', name:'Zam Wesell', artist:null},
      {n:'BC-200', name:'Zorii Bliss', artist:null},
    ]
  },
  {
    id: 'hothfractor-short-print', type: 'insert', title: 'HOTHFRACTOR SHORT PRINT — 200 CARDS',
    parallels: [
      {id:'hoth-ice-blue-frozenfractor',name:'Hoth Ice Blue Frozenfractor',print_run:5,color:'#a8d8ff'},
    ],
    cards: [
      {n:'HF-1', name:'Admiral Ackbar', artist:null},
      {n:'HF-2', name:'Ahsoka Tano', artist:null},
      {n:'HF-3', name:'Anakin Skywalker', artist:null},
      {n:'HF-4', name:'Arvel Skeen', artist:null},
      {n:'HF-5', name:'Baylan Skoll', artist:null},
      {n:'HF-6', name:'Bazil', artist:null},
      {n:'HF-7', name:'Beru Lars', artist:null},
      {n:'HF-8', name:'Birnok', artist:null},
      {n:'HF-9', name:'Bix Caleen', artist:null},
      {n:'HF-10', name:'Bo-Katan Kryze', artist:null},
      {n:'HF-11', name:'Boba Fett', artist:null},
      {n:'HF-12', name:'Bodhi Rook', artist:null},
      {n:'HF-13', name:'C-3PO', artist:null},
      {n:'HF-14', name:'C1-D1', artist:null},
      {n:'HF-15', name:'Captain Blex', artist:null},
      {n:'HF-16', name:'Captain Elk', artist:null},
      {n:'HF-17', name:'Captain Girard', artist:null},
      {n:'HF-18', name:'Captain Hayle', artist:null},
      {n:'HF-19', name:'Captain Phasma', artist:null},
      {n:'HF-20', name:'Captain Porter', artist:null},
      {n:'HF-21', name:'Captain Silvo', artist:null},
      {n:'HF-22', name:'Cassian Andor', artist:null},
      {n:'HF-23', name:'Chewbacca', artist:null},
      {n:'HF-24', name:'Chirrut Îmwe', artist:null},
      {n:'HF-25', name:'Chopper', artist:null},
      {n:'HF-26', name:'Clone Captain Rex', artist:null},
      {n:'HF-27', name:'Count Dooku', artist:null},
      {n:'HF-28', name:'Darth Maul', artist:null},
      {n:'HF-29', name:'Darth Vader', artist:null},
      {n:'HF-30', name:'Dedra Meero', artist:null},
      {n:'HF-31', name:'Dengar', artist:null},
      {n:'HF-32', name:'Dinghy Driver', artist:null},
      {n:'HF-33', name:'DJ', artist:null},
      {n:'HF-34', name:'Dr. Gorst', artist:null},
      {n:'HF-35', name:'Dryden Vos', artist:null},
      {n:'HF-36', name:'Eedy Karn', artist:null},
      {n:'HF-37', name:'Elder Naasa', artist:null},
      {n:'HF-38', name:'Emperor Palpatine', artist:null},
      {n:'HF-39', name:'Ezra Bridger', artist:null},
      {n:'HF-40', name:'Fara', artist:null},
      {n:'HF-41', name:'Fennec Shand', artist:null},
      {n:'HF-42', name:'Fern', artist:null},
      {n:'HF-43', name:'Fifth Brother Inquisitor', artist:null},
      {n:'HF-44', name:'Fillik', artist:null},
      {n:'HF-45', name:'Finn', artist:null},
      {n:'HF-46', name:'First Officer Jensen Corbyt', artist:null},
      {n:'HF-47', name:'Galen Erso', artist:null},
      {n:'HF-48', name:'Garsa Fwip', artist:null},
      {n:'HF-49', name:'General Grievous', artist:null},
      {n:'HF-50', name:'General Hux', artist:null},
      {n:'HF-51', name:'General Pryde', artist:null},
      {n:'HF-52', name:'Grand Admiral Thrawn', artist:null},
      {n:'HF-53', name:'Grand Moff Tarkin', artist:null},
      {n:'HF-54', name:'Greedo', artist:null},
      {n:'HF-55', name:'Greef Karga', artist:null},
      {n:'HF-56', name:'Grogu', artist:null},
      {n:'HF-57', name:'Gunter', artist:null},
      {n:'HF-58', name:'Han Solo', artist:null},
      {n:'HF-59', name:'Hera Syndulla', artist:null},
      {n:'HF-60', name:'IG-11', artist:null},
      {n:'HF-61', name:'Indara', artist:null},
      {n:'HF-62', name:'Jabba The Hutt', artist:null},
      {n:'HF-63', name:'Jar Jar Binks', artist:null},
      {n:'HF-64', name:'Jecki Lon', artist:null},
      {n:'HF-65', name:'Jod Na Nawood', artist:null},
      {n:'HF-66', name:'Jyn Erso', artist:null},
      {n:'HF-67', name:'K-2SO', artist:null},
      {n:'HF-68', name:'Karis Nemik', artist:null},
      {n:'HF-69', name:'Kassa', artist:null},
      {n:'HF-70', name:'Kawlan Roken', artist:null},
      {n:'HF-71', name:'Kaydel Connix', artist:null},
      {n:'HF-72', name:'Kelleran Beq', artist:null},
      {n:'HF-73', name:'Kelnacca', artist:null},
      {n:'HF-74', name:'Kh\'ymm', artist:null},
      {n:'HF-75', name:'Klothow', artist:null},
      {n:'HF-76', name:'Koska Reeves', artist:null},
      {n:'HF-77', name:'L3-37', artist:null},
      {n:'HF-78', name:'Lando Calrissian', artist:null},
      {n:'HF-79', name:'Lando Calrissian', artist:null},
      {n:'HF-80', name:'Leia Organa', artist:null},
      {n:'HF-81', name:'Logray', artist:null},
      {n:'HF-82', name:'Lor San Tekka', artist:null},
      {n:'HF-83', name:'Luke Skywalker', artist:null},
      {n:'HF-84', name:'Luthen Rael', artist:null},
      {n:'HF-85', name:'Mace Windu', artist:null},
      {n:'HF-86', name:'Mae Aniseya', artist:null},
      {n:'HF-87', name:'Maree', artist:null},
      {n:'HF-88', name:'Master Codebreaker', artist:null},
      {n:'HF-89', name:'Max Rebo', artist:null},
      {n:'HF-90', name:'Maz Kanata', artist:null},
      {n:'HF-91', name:'Moff Gideon', artist:null},
      {n:'HF-92', name:'Mog Adana', artist:null},
      {n:'HF-93', name:'Mon Mothma', artist:null},
      {n:'HF-94', name:'Mother Aniseya', artist:null},
      {n:'HF-95', name:'Mother Koril', artist:null},
      {n:'HF-96', name:'Nol', artist:null},
      {n:'HF-97', name:'Pokkit', artist:null},
      {n:'HF-98', name:'Skull Ridge Mountain Hotelier', artist:null},
      {n:'HF-99', name:'SM-33', artist:null},
      {n:'HF-100', name:'Trash crab', artist:null},
      {n:'HF-101', name:'2-1B Droid', artist:null},
      {n:'HF-102', name:'Adi Gallia', artist:null},
      {n:'HF-103', name:'Aemon Gremm', artist:null},
      {n:'HF-104', name:'Bazine Netal', artist:null},
      {n:'HF-105', name:'BB-9E', artist:null},
      {n:'HF-106', name:'Beaumont Kin', artist:null},
      {n:'HF-107', name:'Benjar Pranic', artist:null},
      {n:'HF-108', name:'Bossk', artist:null},
      {n:'HF-109', name:'Brasso', artist:null},
      {n:'HF-110', name:'Cabuck', artist:null},
      {n:'HF-111', name:'Chancellor Drellik', artist:null},
      {n:'HF-112', name:'Chief Chirpa', artist:null},
      {n:'HF-113', name:'Darth Bane', artist:null},
      {n:'HF-114', name:'Dokk Strassi', artist:null},
      {n:'HF-115', name:'Enfys Nest', artist:null},
      {n:'HF-116', name:'Figrin D\'an', artist:null},
      {n:'HF-117', name:'Fuzzball', artist:null},
      {n:'HF-118', name:'Fyrnock', artist:null},
      {n:'HF-119', name:'General Pong Krell', artist:null},
      {n:'HF-120', name:'General Strix', artist:null},
      {n:'HF-121', name:'Glerb', artist:null},
      {n:'HF-122', name:'Hayna', artist:null},
      {n:'HF-123', name:'Hondo Ohnaka', artist:null},
      {n:'HF-124', name:'IG-88', artist:null},
      {n:'HF-125', name:'Jawa', artist:null},
      {n:'HF-126', name:'Jess Pava', artist:null},
      {n:'HF-127', name:'Kayo Organa', artist:null},
      {n:'HF-128', name:'KB', artist:null},
      {n:'HF-129', name:'Kona', artist:null},
      {n:'HF-130', name:'Kragan Gorr', artist:null},
      {n:'HF-131', name:'Lobot', artist:null},
      {n:'HF-132', name:'Lortha Peel', artist:null},
      {n:'HF-133', name:'Mas Amedda', artist:null},
      {n:'HF-134', name:'Mayor Mok Shaiz', artist:null},
      {n:'HF-135', name:'Melna', artist:null},
      {n:'HF-136', name:'Mother Talzin', artist:null},
      {n:'HF-137', name:'Neel', artist:null},
      {n:'HF-138', name:'Obi-Wan Kenobi', artist:null},
      {n:'HF-139', name:'Obi-Wan Kenobi', artist:null},
      {n:'HF-140', name:'Osha Aniseya', artist:null},
      {n:'HF-141', name:'Padmé Amidala', artist:null},
      {n:'HF-142', name:'Pegla', artist:null},
      {n:'HF-143', name:'Pip', artist:null},
      {n:'HF-144', name:'Pirate Captain Brutus', artist:null},
      {n:'HF-145', name:'Poe Dameron', artist:null},
      {n:'HF-146', name:'Poggle the Lesser', artist:null},
      {n:'HF-147', name:'Porg', artist:null},
      {n:'HF-148', name:'Professor Huyang', artist:null},
      {n:'HF-149', name:'Pyke Boss', artist:null},
      {n:'HF-150', name:'Qi\'ra', artist:null},
      {n:'HF-151', name:'Queen Apailana', artist:null},
      {n:'HF-152', name:'Qui-Gon Jinn', artist:null},
      {n:'HF-153', name:'R2-D2', artist:null},
      {n:'HF-154', name:'Ragnar Vizsla', artist:null},
      {n:'HF-155', name:'Rey', artist:null},
      {n:'HF-156', name:'Rio Durant', artist:null},
      {n:'HF-157', name:'Roona', artist:null},
      {n:'HF-158', name:'Rose Tico', artist:null},
      {n:'HF-159', name:'Sabé', artist:null},
      {n:'HF-160', name:'Sabine Wren', artist:null},
      {n:'HF-161', name:'Safety Droid', artist:null},
      {n:'HF-162', name:'Savage Opress', artist:null},
      {n:'HF-163', name:'Senator Rayencourt', artist:null},
      {n:'HF-164', name:'Sergeant Linus Mosk', artist:null},
      {n:'HF-165', name:'Shaak Ti', artist:null},
      {n:'HF-166', name:'Shin Hati', artist:null},
      {n:'HF-167', name:'Skura', artist:null},
      {n:'HF-168', name:'Slowen Lo', artist:null},
      {n:'HF-169', name:'Sly Moore', artist:null},
      {n:'HF-170', name:'Snowball', artist:null},
      {n:'HF-171', name:'Sol', artist:null},
      {n:'HF-172', name:'Sully Stark', artist:null},
      {n:'HF-173', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'HF-174', name:'Supreme Leader Snoke', artist:null},
      {n:'HF-175', name:'Tasi Lowa', artist:null},
      {n:'HF-176', name:'Teacher Droid', artist:null},
      {n:'HF-177', name:'Tera Sinube', artist:null},
      {n:'HF-178', name:'The Armorer', artist:null},
      {n:'HF-179', name:'The Client', artist:null},
      {n:'HF-180', name:'The Grand Inquisitor', artist:null},
      {n:'HF-181', name:'The Mandalorian', artist:null},
      {n:'HF-182', name:'The Stranger', artist:null},
      {n:'HF-183', name:'Tion Medon', artist:null},
      {n:'HF-184', name:'Tobias Beckett', artist:null},
      {n:'HF-185', name:'Torbin', artist:null},
      {n:'HF-186', name:'Unkar Plutt', artist:null},
      {n:'HF-187', name:'Val', artist:null},
      {n:'HF-188', name:'Vernestra Rwoh', artist:null},
      {n:'HF-189', name:'Vetch', artist:null},
      {n:'HF-190', name:'Watto', artist:null},
      {n:'HF-191', name:'Wendle', artist:null},
      {n:'HF-192', name:'Wilmon Paak', artist:null},
      {n:'HF-193', name:'Wim', artist:null},
      {n:'HF-194', name:'Wullf Yularen', artist:null},
      {n:'HF-195', name:'Xanwan', artist:null},
      {n:'HF-196', name:'Yarael Poof', artist:null},
      {n:'HF-197', name:'Yoda', artist:null},
      {n:'HF-198', name:'Yord Fandar', artist:null},
      {n:'HF-199', name:'Zam Wesell', artist:null},
      {n:'HF-200', name:'Zorii Bliss', artist:null},
    ]
  },
  {
    id: 'aurebesh-short-print', type: 'insert', title: 'AUREBESH SHORT PRINT — 200 CARDS',
    // The base Aurebesh SP is itself serial /99 (all 200 AVs are /99), so it needs a
    // rule-6 serial slot or collectors cannot record which copy they own. Blank name
    // renders as "#'d /99".
    parallels: [{id:'base',name:'',print_run:99,color:'#c8d8f0'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'AV-1', name:'Admiral Ackbar', artist:null},
      {n:'AV-2', name:'Ahsoka Tano', artist:null},
      {n:'AV-3', name:'Anakin Skywalker', artist:null},
      {n:'AV-4', name:'Arvel Skeen', artist:null},
      {n:'AV-5', name:'Baylan Skoll', artist:null},
      {n:'AV-6', name:'Bazil', artist:null},
      {n:'AV-7', name:'Beru Lars', artist:null},
      {n:'AV-8', name:'Birnok', artist:null},
      {n:'AV-9', name:'Bix Caleen', artist:null},
      {n:'AV-10', name:'Bo-Katan Kryze', artist:null},
      {n:'AV-11', name:'Boba Fett', artist:null},
      {n:'AV-12', name:'Bodhi Rook', artist:null},
      {n:'AV-13', name:'C-3PO', artist:null},
      {n:'AV-14', name:'C1-D1', artist:null},
      {n:'AV-15', name:'Captain Blex', artist:null},
      {n:'AV-16', name:'Captain Elk', artist:null},
      {n:'AV-17', name:'Captain Girard', artist:null},
      {n:'AV-18', name:'Captain Hayle', artist:null},
      {n:'AV-19', name:'Captain Phasma', artist:null},
      {n:'AV-20', name:'Captain Porter', artist:null},
      {n:'AV-21', name:'Captain Silvo', artist:null},
      {n:'AV-22', name:'Cassian Andor', artist:null},
      {n:'AV-23', name:'Chewbacca', artist:null},
      {n:'AV-24', name:'Chirrut Imwe', artist:null},
      {n:'AV-25', name:'Chopper', artist:null},
      {n:'AV-26', name:'Clone Captain Rex', artist:null},
      {n:'AV-27', name:'Count Dooku', artist:null},
      {n:'AV-28', name:'Darth Maul', artist:null},
      {n:'AV-29', name:'Darth Vader', artist:null},
      {n:'AV-30', name:'Dedra Meero', artist:null},
      {n:'AV-31', name:'Dengar', artist:null},
      {n:'AV-32', name:'Dinghy Driver', artist:null},
      {n:'AV-33', name:'DJ', artist:null},
      {n:'AV-34', name:'Dr. Gorst', artist:null},
      {n:'AV-35', name:'Dryden Vos', artist:null},
      {n:'AV-36', name:'Eedy Karn', artist:null},
      {n:'AV-37', name:'Elder Naasa', artist:null},
      {n:'AV-38', name:'Emperor Palpatine', artist:null},
      {n:'AV-39', name:'Ezra Bridger', artist:null},
      {n:'AV-40', name:'Fara', artist:null},
      {n:'AV-41', name:'Fennec Shand', artist:null},
      {n:'AV-42', name:'Fern', artist:null},
      {n:'AV-43', name:'Fifth Brother Inquisitor', artist:null},
      {n:'AV-44', name:'Fillik', artist:null},
      {n:'AV-45', name:'Finn', artist:null},
      {n:'AV-46', name:'First Officer Jensen Corbyt', artist:null},
      {n:'AV-47', name:'Galen Erso', artist:null},
      {n:'AV-48', name:'Garsa Fwip', artist:null},
      {n:'AV-49', name:'General Grievous', artist:null},
      {n:'AV-50', name:'General Hux', artist:null},
      {n:'AV-51', name:'General Pryde', artist:null},
      {n:'AV-52', name:'Grand Admiral Thrawn', artist:null},
      {n:'AV-53', name:'Grand Moff Tarkin', artist:null},
      {n:'AV-54', name:'Greedo', artist:null},
      {n:'AV-55', name:'Greef Karga', artist:null},
      {n:'AV-56', name:'Grogu', artist:null},
      {n:'AV-57', name:'Gunter', artist:null},
      {n:'AV-58', name:'Han Solo', artist:null},
      {n:'AV-59', name:'Hera Syndulla', artist:null},
      {n:'AV-60', name:'IG-11', artist:null},
      {n:'AV-61', name:'Indara', artist:null},
      {n:'AV-62', name:'Jabba The Hutt', artist:null},
      {n:'AV-63', name:'Jar Jar Binks', artist:null},
      {n:'AV-64', name:'Jecki Lon', artist:null},
      {n:'AV-65', name:'Jod Na Nawood', artist:null},
      {n:'AV-66', name:'Jyn Erso', artist:null},
      {n:'AV-67', name:'K-2SO', artist:null},
      {n:'AV-68', name:'Karis Nemik', artist:null},
      {n:'AV-69', name:'Kassa', artist:null},
      {n:'AV-70', name:'Kawlan Roken', artist:null},
      {n:'AV-71', name:'Kaydel Connix', artist:null},
      {n:'AV-72', name:'Kelleran Beq', artist:null},
      {n:'AV-73', name:'Kelnacca', artist:null},
      {n:'AV-74', name:'Kh\'ymm', artist:null},
      {n:'AV-75', name:'Klothow', artist:null},
      {n:'AV-76', name:'Koska Reeves', artist:null},
      {n:'AV-77', name:'L3-37', artist:null},
      {n:'AV-78', name:'Lando Calrissian', artist:null},
      {n:'AV-79', name:'Lando Calrissian', artist:null},
      {n:'AV-80', name:'Leia Organa', artist:null},
      {n:'AV-81', name:'Logray', artist:null},
      {n:'AV-82', name:'Lor San Tekka', artist:null},
      {n:'AV-83', name:'Luke Skywalker', artist:null},
      {n:'AV-84', name:'Luthen Rael', artist:null},
      {n:'AV-85', name:'Mace Windu', artist:null},
      {n:'AV-86', name:'Mae Aniseya', artist:null},
      {n:'AV-87', name:'Maree', artist:null},
      {n:'AV-88', name:'Master Codebreaker', artist:null},
      {n:'AV-89', name:'Max Rebo', artist:null},
      {n:'AV-90', name:'Maz Kanata', artist:null},
      {n:'AV-91', name:'Moff Gideon', artist:null},
      {n:'AV-92', name:'Mog Adana', artist:null},
      {n:'AV-93', name:'Mon Mothma', artist:null},
      {n:'AV-94', name:'Mother Aniseya', artist:null},
      {n:'AV-95', name:'Mother Koril', artist:null},
      {n:'AV-96', name:'Nol', artist:null},
      {n:'AV-97', name:'Pokkit', artist:null},
      {n:'AV-98', name:'Skull Ridge Mountain Hotelier', artist:null},
      {n:'AV-99', name:'SM-33', artist:null},
      {n:'AV-100', name:'Trash crab', artist:null},
      {n:'AV-101', name:'2-1B Droid', artist:null},
      {n:'AV-102', name:'Adi Gallia', artist:null},
      {n:'AV-103', name:'Aemon Gremm', artist:null},
      {n:'AV-104', name:'Bazine Netal', artist:null},
      {n:'AV-105', name:'BB-9E', artist:null},
      {n:'AV-106', name:'Beaumont Kin', artist:null},
      {n:'AV-107', name:'Benjar Pranic', artist:null},
      {n:'AV-108', name:'Bossk', artist:null},
      {n:'AV-109', name:'Brasso', artist:null},
      {n:'AV-110', name:'Cabuck', artist:null},
      {n:'AV-111', name:'Chancellor Drellik', artist:null},
      {n:'AV-112', name:'Chief Chirpa', artist:null},
      {n:'AV-113', name:'Darth Bane', artist:null},
      {n:'AV-114', name:'Dokk Strassi', artist:null},
      {n:'AV-115', name:'Enfys Nest', artist:null},
      {n:'AV-116', name:'Figrin D\'an', artist:null},
      {n:'AV-117', name:'Fuzzball', artist:null},
      {n:'AV-118', name:'Fyrnock', artist:null},
      {n:'AV-119', name:'General Pong Krell', artist:null},
      {n:'AV-120', name:'General Strix', artist:null},
      {n:'AV-121', name:'Glerb', artist:null},
      {n:'AV-122', name:'Hayna', artist:null},
      {n:'AV-123', name:'Hondo Ohnaka', artist:null},
      {n:'AV-124', name:'IG-88', artist:null},
      {n:'AV-125', name:'Jawa', artist:null},
      {n:'AV-126', name:'Jess Pava', artist:null},
      {n:'AV-127', name:'Kayo Organa', artist:null},
      {n:'AV-128', name:'KB', artist:null},
      {n:'AV-129', name:'Kona', artist:null},
      {n:'AV-130', name:'Kragan Gorr', artist:null},
      {n:'AV-131', name:'Lobot', artist:null},
      {n:'AV-132', name:'Lortha Peel', artist:null},
      {n:'AV-133', name:'Mas Amedda', artist:null},
      {n:'AV-134', name:'Mayor Mok Shaiz', artist:null},
      {n:'AV-135', name:'Melna', artist:null},
      {n:'AV-136', name:'Mother Talzin', artist:null},
      {n:'AV-137', name:'Neel', artist:null},
      {n:'AV-138', name:'Obi-Wan Kenobi', artist:null},
      {n:'AV-139', name:'Obi-Wan Kenobi', artist:null},
      {n:'AV-140', name:'Osha Aniseya', artist:null},
      {n:'AV-141', name:'Padmé Amidala', artist:null},
      {n:'AV-142', name:'Pegla', artist:null},
      {n:'AV-143', name:'Pip', artist:null},
      {n:'AV-144', name:'Pirate Captain Brutus', artist:null},
      {n:'AV-145', name:'Poe Dameron', artist:null},
      {n:'AV-146', name:'Poggle the Lesser', artist:null},
      {n:'AV-147', name:'Porg', artist:null},
      {n:'AV-148', name:'Professor Huyang', artist:null},
      {n:'AV-149', name:'Pyke Boss', artist:null},
      {n:'AV-150', name:'Qi\'ra', artist:null},
      {n:'AV-151', name:'Queen Apailana', artist:null},
      {n:'AV-152', name:'Qui-Gon Jinn', artist:null},
      {n:'AV-153', name:'R2-D2', artist:null},
      {n:'AV-154', name:'Ragnar Vizsla', artist:null},
      {n:'AV-155', name:'Rey', artist:null},
      {n:'AV-156', name:'Rio Durant', artist:null},
      {n:'AV-157', name:'Roona', artist:null},
      {n:'AV-158', name:'Rose Tico', artist:null},
      {n:'AV-159', name:'Sabé', artist:null},
      {n:'AV-160', name:'Sabine Wren', artist:null},
      {n:'AV-161', name:'Safety Droid', artist:null},
      {n:'AV-162', name:'Savage Opress', artist:null},
      {n:'AV-163', name:'Senator Rayencourt', artist:null},
      {n:'AV-164', name:'Sergeant Linus Mosk', artist:null},
      {n:'AV-165', name:'Shaak Ti', artist:null},
      {n:'AV-166', name:'Shin Hati', artist:null},
      {n:'AV-167', name:'Skura', artist:null},
      {n:'AV-168', name:'Slowen Lo', artist:null},
      {n:'AV-169', name:'Sly Moore', artist:null},
      {n:'AV-170', name:'Snowball', artist:null},
      {n:'AV-171', name:'Sol', artist:null},
      {n:'AV-172', name:'Sully Stark', artist:null},
      {n:'AV-173', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'AV-174', name:'Supreme Leader Snoke', artist:null},
      {n:'AV-175', name:'Tasi Lowa', artist:null},
      {n:'AV-176', name:'Teacher Droid', artist:null},
      {n:'AV-177', name:'Tera Sinube', artist:null},
      {n:'AV-178', name:'The Armorer', artist:null},
      {n:'AV-179', name:'The Client', artist:null},
      {n:'AV-180', name:'The Grand Inquisitor', artist:null},
      {n:'AV-181', name:'The Mandalorian', artist:null},
      {n:'AV-182', name:'The Stranger', artist:null},
      {n:'AV-183', name:'Tion Medon', artist:null},
      {n:'AV-184', name:'Tobias Beckett', artist:null},
      {n:'AV-185', name:'Torbin', artist:null},
      {n:'AV-186', name:'Unkar Plutt', artist:null},
      {n:'AV-187', name:'Val', artist:null},
      {n:'AV-188', name:'Vernestra Rwoh', artist:null},
      {n:'AV-189', name:'Vetch', artist:null},
      {n:'AV-190', name:'Watto', artist:null},
      {n:'AV-191', name:'Wendle', artist:null},
      {n:'AV-192', name:'Wilmon Paak', artist:null},
      {n:'AV-193', name:'Wim', artist:null},
      {n:'AV-194', name:'Wullf Yularen', artist:null},
      {n:'AV-195', name:'Xanwan', artist:null},
      {n:'AV-196', name:'Yarael Poof', artist:null},
      {n:'AV-197', name:'Yoda', artist:null},
      {n:'AV-198', name:'Yord Fandar', artist:null},
      {n:'AV-199', name:'Zam Wesell', artist:null},
      {n:'AV-200', name:'Zorii Bliss', artist:null},
    ]
  },
  {
    id: '1975-tribute', type: 'insert', title: '1975 TRIBUTE — 50 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'TB-1', name:'Admiral Ackbar', artist:null},
      {n:'TB-2', name:'Ahsoka Tano', artist:null},
      {n:'TB-3', name:'Anakin Skywalker', artist:null},
      {n:'TB-4', name:'Bail Organa', artist:null},
      {n:'TB-5', name:'Baylan Skoll', artist:null},
      {n:'TB-6', name:'Bo-Katan Kryze', artist:null},
      {n:'TB-7', name:'Boba Fett', artist:null},
      {n:'TB-8', name:'C-3PO', artist:null},
      {n:'TB-9', name:'Captain Phasma', artist:null},
      {n:'TB-10', name:'Cassian Andor', artist:null},
      {n:'TB-11', name:'Chewbacca', artist:null},
      {n:'TB-12', name:'Chirrut Îmwe', artist:null},
      {n:'TB-13', name:'Count Dooku', artist:null},
      {n:'TB-14', name:'Darth Maul', artist:null},
      {n:'TB-15', name:'Darth Vader', artist:null},
      {n:'TB-16', name:'Emperor Palpatine', artist:null},
      {n:'TB-17', name:'General Grievous', artist:null},
      {n:'TB-18', name:'General Hux', artist:null},
      {n:'TB-19', name:'Grand Admiral Thrawn', artist:null},
      {n:'TB-20', name:'Grand Moff Tarkin', artist:null},
      {n:'TB-21', name:'Greedo', artist:null},
      {n:'TB-22', name:'Greef Karga', artist:null},
      {n:'TB-23', name:'Grogu', artist:null},
      {n:'TB-24', name:'Han Solo', artist:null},
      {n:'TB-25', name:'Hera Syndulla', artist:null},
      {n:'TB-26', name:'IG-11', artist:null},
      {n:'TB-27', name:'Jabba The Hutt', artist:null},
      {n:'TB-28', name:'Jar Jar Binks', artist:null},
      {n:'TB-29', name:'Jod Na Nawood', artist:null},
      {n:'TB-30', name:'Jyn Erso', artist:null},
      {n:'TB-31', name:'Lando Calrissian', artist:null},
      {n:'TB-32', name:'Lando Calrissian', artist:null},
      {n:'TB-33', name:'Leia Organa', artist:null},
      {n:'TB-34', name:'Luke Skywalker', artist:null},
      {n:'TB-35', name:'Mace Windu', artist:null},
      {n:'TB-36', name:'Moff Gideon', artist:null},
      {n:'TB-37', name:'Mon Mothma', artist:null},
      {n:'TB-38', name:'Nien Nunb', artist:null},
      {n:'TB-39', name:'Obi-Wan Kenobi', artist:null},
      {n:'TB-40', name:'Obi-Wan Kenobi', artist:null},
      {n:'TB-41', name:'Padmé Amidala', artist:null},
      {n:'TB-42', name:'Qui-Gon Jinn', artist:null},
      {n:'TB-43', name:'R2-D2', artist:null},
      {n:'TB-44', name:'Sabine Wren', artist:null},
      {n:'TB-45', name:'Shin Hati', artist:null},
      {n:'TB-46', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'TB-47', name:'The Armorer', artist:null},
      {n:'TB-48', name:'The Mandalorian', artist:null},
      {n:'TB-49', name:'Wicket W. Warrick', artist:null},
      {n:'TB-50', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'skeleton-crew', type: 'insert', title: 'SKELETON CREW — 25 CARDS',
    parallels: [{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'SC-1', name:'Captain Silvo', artist:null},
      {n:'SC-2', name:'Wim and Neel Shuttle To Class', artist:null},
      {n:'SC-3', name:'Fern and KB Speed To Class', artist:null},
      {n:'SC-4', name:'Preparing For Career Day', artist:null},
      {n:'SC-5', name:'"What Are You In For?"', artist:null},
      {n:'SC-6', name:'Discovering The Onyx Cinder', artist:null},
      {n:'SC-7', name:'SM-33 and Snowball', artist:null},
      {n:'SC-8', name:'Jumping Into Hyperdrive', artist:null},
      {n:'SC-9', name:'Docking At Port Borgo', artist:null},
      {n:'SC-10', name:'Jod Na Nawood', artist:null},
      {n:'SC-11', name:'Kh\'ymm Helps The Children', artist:null},
      {n:'SC-12', name:'Neel And Hayna', artist:null},
      {n:'SC-13', name:'The Crew Gets Enlisted', artist:null},
      {n:'SC-14', name:'The Wise Elders', artist:null},
      {n:'SC-15', name:'Tak Rennod\'s Lair', artist:null},
      {n:'SC-16', name:'Jod Captured', artist:null},
      {n:'SC-17', name:'Equal Time', artist:null},
      {n:'SC-18', name:'Jod Rallies The Pirates', artist:null},
      {n:'SC-19', name:'The Crew Reunites', artist:null},
      {n:'SC-20', name:'The Crew Finds At Attin', artist:null},
      {n:'SC-21', name:'Jod Threatens The Crew', artist:null},
      {n:'SC-22', name:'Jod Finds His Treasure', artist:null},
      {n:'SC-23', name:'Racing To Save At Attin', artist:null},
      {n:'SC-24', name:'The Supervisor Revealed', artist:null},
      {n:'SC-25', name:'The Real Good Guys Save At Attin', artist:null},
    ]
  },
  {
    id: 'acolyte', type: 'insert', title: 'ACOLYTE — 25 CARDS',
    parallels: [{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'AC-1', name:'Mae Aniseya Defeats Jedi Master Indara', artist:null},
      {n:'AC-2', name:'A Crash On Carlac', artist:null},
      {n:'AC-3', name:'Jedi Master Sol Saves Osha Aniseya', artist:null},
      {n:'AC-4', name:'Mae Aniseya\'s Next Assignment', artist:null},
      {n:'AC-5', name:'Bottled Absolution', artist:null},
      {n:'AC-6', name:'Tracking Down Mae Aniseya', artist:null},
      {n:'AC-7', name:'The Power Of Many', artist:null},
      {n:'AC-8', name:'The Twins Are Tested', artist:null},
      {n:'AC-9', name:'A Deadly Fire', artist:null},
      {n:'AC-10', name:'Mae Aniseya Changes Course', artist:null},
      {n:'AC-11', name:'The Stranger Vs The Jedi', artist:null},
      {n:'AC-12', name:'The Stranger, Unmasked', artist:null},
      {n:'AC-13', name:'Mae Aniseya Assumes Osha\'s Identity', artist:null},
      {n:'AC-14', name:'Osha Aniseya Threatens Qimir', artist:null},
      {n:'AC-15', name:'Osha Aniseya Wears The Cortosis Helmet', artist:null},
      {n:'AC-16', name:'Vernestra Rwoh', artist:null},
      {n:'AC-17', name:'Master Sol Finds The Twins', artist:null},
      {n:'AC-18', name:'The Jedi Search For A Vergence', artist:null},
      {n:'AC-19', name:'Kelnacca Unleashed', artist:null},
      {n:'AC-20', name:'The Witches Perish', artist:null},
      {n:'AC-21', name:'A Sith Lord Observes', artist:null},
      {n:'AC-22', name:'Sol Vs Qimir', artist:null},
      {n:'AC-23', name:'Without A Weapon', artist:null},
      {n:'AC-24', name:'The Bleeding Of A Kyber Crystal', artist:null},
      {n:'AC-25', name:'Memory Loss', artist:null},
    ]
  },
  {
    id: 'underworld-oddities', type: 'insert', title: 'OUTER WORLD ODDITIES — 25 CARDS',
    parallels: [{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'UO-1', name:'Acklay', artist:null},
      {n:'UO-2', name:'Brain Worm', artist:null},
      {n:'UO-3', name:'Colo Claw Fish', artist:null},
      {n:'UO-4', name:'Fyrnock', artist:null},
      {n:'UO-5', name:'Gundark', artist:null},
      {n:'UO-6', name:'Ice Spider', artist:null},
      {n:'UO-7', name:'Irling', artist:null},
      {n:'UO-8', name:'Kouhun', artist:null},
      {n:'UO-9', name:'Krayt Dragon', artist:null},
      {n:'UO-10', name:'Krykna', artist:null},
      {n:'UO-11', name:'Blurrg', artist:null},
      {n:'UO-12', name:'Nexu', artist:null},
      {n:'UO-13', name:'Rancor', artist:null},
      {n:'UO-14', name:'Rathtar', artist:null},
      {n:'UO-15', name:'Ravinak', artist:null},
      {n:'UO-16', name:'Rokkna', artist:null},
      {n:'UO-17', name:'Tatooine sand beast', artist:null},
      {n:'UO-18', name:'Sando Aqua Monster', artist:null},
      {n:'UO-19', name:'Sarlacc', artist:null},
      {n:'UO-20', name:'Space Slug', artist:null},
      {n:'UO-21', name:'Summa-Verminoth', artist:null},
      {n:'UO-22', name:'Vexis', artist:null},
      {n:'UO-23', name:'Vixus', artist:null},
      {n:'UO-24', name:'Wampa', artist:null},
      {n:'UO-25', name:'Zillo Beast', artist:null},
    ]
  },
  {
    id: 'star-wars-by-the-number', type: 'insert', title: 'STAR WARS BY THE NUMBER — 24 CARDS',
    parallels: [],
    cards: [
      {n:'CP-1', name:'R2-D2', artist:null},
      {n:'CP-2', name:'Boba Fett', artist:null},
      {n:'CP-3', name:'Han Solo, Leia Organa and Luke Skywalker', artist:null},
      {n:'CP-4', name:'Jabba the Hutt, Bib Fortuna and Salacious B. Crumb', artist:null},
      {n:'CP-5', name:'Max Rebo', artist:null},
      {n:'CP-6', name:'Imperial Royal Guard', artist:null},
      {n:'CP-7', name:'Darth Vader', artist:null},
      {n:'CP-8', name:'Yoda', artist:null},
      {n:'CP-9', name:'Han Solo in Carbonite and Boushh', artist:null},
      {n:'CP-10', name:'Darth Vader, Luke Skywalker and Emperor Palpatine', artist:null},
      {n:'CP-11', name:'Darth Vader and Emperor Palpatine', artist:null},
      {n:'CP-12', name:'Jawas', artist:null},
      {n:'CP-13', name:'Star Destroyer', artist:null},
      {n:'CP-14', name:'Stormtrooper', artist:null},
      {n:'CP-15', name:'Starfighters', artist:null},
      {n:'CP-16', name:'Chewbacca', artist:null},
      {n:'CP-17', name:'Millennium Falcon', artist:null},
      {n:'CP-18', name:'Lando Calrissian', artist:null},
      {n:'CP-19', name:'Darth Vader vs Luke Skywalker', artist:null},
      {n:'CP-20', name:'May the Force Be With You', artist:null},
      {n:'CP-21', name:'C-3PO & R2-D2', artist:null},
      {n:'CP-22', name:'Stormtrooper', artist:null},
      {n:'CP-23', name:'Luke Skywalker & Yoda', artist:null},
      {n:'CP-24', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'galactic-graffiti', type: 'insert', title: 'GALACTIC GRAFFITI — 21 CARDS',
    parallels: [{id:'mini-diamond-refractor',name:'Mini Diamonds Refractor',print_run:50,color:'#c8cad8'},{id:'mojo-refractor',name:'Mojo Refractor',print_run:25,color:'#ff9d52'},{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'GG-1', name:'Ahsoka Tano', artist:null},
      {n:'GG-2', name:'Baylan Skoll', artist:null},
      {n:'GG-3', name:'BB-8', artist:null},
      {n:'GG-4', name:'Boba Fett', artist:null},
      {n:'GG-5', name:'C-3P0 & R2-D2', artist:null},
      {n:'GG-6', name:'Captain Phasma', artist:null},
      {n:'GG-7', name:'Cassian Andor', artist:null},
      {n:'GG-8', name:'Chewbacca', artist:null},
      {n:'GG-9', name:'Darth Maul', artist:null},
      {n:'GG-10', name:'Ezra Bridger', artist:null},
      {n:'GG-11', name:'Grand Admiral Thrawn', artist:null},
      {n:'GG-12', name:'Jecki Lon', artist:null},
      {n:'GG-13', name:'Mace Windu', artist:null},
      {n:'GG-14', name:'Mae Aniseya', artist:null},
      {n:'GG-15', name:'Obi-Wan Kenobi', artist:null},
      {n:'GG-16', name:'Padmé Amidala', artist:null},
      {n:'GG-17', name:'Sabine Wren', artist:null},
      {n:'GG-18', name:'Stormtooper', artist:null},
      {n:'GG-19', name:'The Mandalorian', artist:null},
      {n:'GG-20', name:'The Stranger', artist:null},
      {n:'GG-21', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'bonus-stage', type: 'insert', title: 'BONUS STAGE — 10 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'BS-AV', name:'Asajj Ventress', artist:null},
      {n:'BS-BK', name:'Bo-Katan Kryze', artist:null},
      {n:'BS-CB', name:'Cad Bane', artist:null},
      {n:'BS-F', name:'Fives', artist:null},
      {n:'BS-HO', name:'Hondo Ohnaka', artist:null},
      {n:'BS-HS', name:'Hera Syndulla', artist:null},
      {n:'BS-M', name:'Darth Maul', artist:null},
      {n:'BS-SG', name:'Saw Gerrera', artist:null},
      {n:'BS-SO', name:'Savage Opress', artist:null},
      {n:'BS-T', name:'Grand Admiral Thrawn', artist:null},
    ]
  },
  {
    id: 'kyber-light', type: 'insert', title: 'KYBER LIGHT — 20 CARDS',
    parallels: [{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'KL-1', name:'Admiral Ackbar', artist:null},
      {n:'KL-2', name:'Ahsoka Tano', artist:null},
      {n:'KL-3', name:'Baylan Skoll', artist:null},
      {n:'KL-4', name:'BB-8', artist:null},
      {n:'KL-5', name:'C-3PO', artist:null},
      {n:'KL-6', name:'Chewbacca', artist:null},
      {n:'KL-7', name:'Darth Maul', artist:null},
      {n:'KL-8', name:'Figrin D\'an', artist:null},
      {n:'KL-9', name:'Greedo', artist:null},
      {n:'KL-10', name:'Han Solo', artist:null},
      {n:'KL-11', name:'IG-88', artist:null},
      {n:'KL-12', name:'Jabba the Hutt', artist:null},
      {n:'KL-13', name:'Jar Jar Binks', artist:null},
      {n:'KL-14', name:'Luke Skywalker', artist:null},
      {n:'KL-15', name:'Max Rebo', artist:null},
      {n:'KL-16', name:'Maz Kanata', artist:null},
      {n:'KL-17', name:'Padmé Amidala', artist:null},
      {n:'KL-18', name:'Stormtrooper', artist:null},
      {n:'KL-19', name:'The Mandalorian And Grogu', artist:null},
      {n:'KL-20', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'reflections', type: 'insert', title: 'REFLECTIONS — 5 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'R-11', name:'C-3PO', artist:null},
      {n:'R-12', name:'Crossing Paths', artist:null},
      {n:'R-13', name:'Showdown on Scarif', artist:null},
      {n:'R-14', name:'Want Some Soup', artist:null},
      {n:'R-15', name:'Geonosis Reflections', artist:null},
    ]
  },
  {
    id: 'comicfractor', type: 'insert', title: 'COMICFRACTOR — 5 CARDS',
    parallels: [{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'VC-6', name:'Anakin Skywalker', artist:null},
      {n:'VC-7', name:'Boba Fett', artist:null},
      {n:'VC-8', name:'Queen Padmé Amidala', artist:null},
      {n:'VC-9', name:'Artoo-Detoo', artist:null},
      {n:'VC-10', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'one-with-the-force', type: 'insert', title: 'ONE WITH THE FORCE — 5 CARDS',
    parallels: [],
    cards: [
      {n:'OF-6', name:'Ben Solo', artist:null},
      {n:'OF-7', name:'Chirrut Îmwe', artist:null},
      {n:'OF-8', name:'Leia Organa', artist:null},
      {n:'OF-9', name:'Luke Skywalker', artist:null},
      {n:'OF-10', name:'Mace Windu', artist:null},
    ]
  },
  {
    id: 'double-vision', type: 'insert', title: 'DOUBLE VISION — 25 CARDS',
    parallels: [],
    cards: [
      {n:'DV-1', name:'Ahsoka Tano', artist:null},
      {n:'DV-2', name:'Anakin Skywalker', artist:null},
      {n:'DV-3', name:'Aurra Sing', artist:null},
      {n:'DV-4', name:'Bo-Katan Kryze', artist:null},
      {n:'DV-5', name:'Cad Bane', artist:null},
      {n:'DV-6', name:'Chewbacca', artist:null},
      {n:'DV-7', name:'Clone Captain Rex', artist:null},
      {n:'DV-8', name:'Count Dooku', artist:null},
      {n:'DV-9', name:'Darth Sidious', artist:null},
      {n:'DV-10', name:'Ezra Bridger', artist:null},
      {n:'DV-11', name:'Garazeb "Zeb" Orrelios', artist:null},
      {n:'DV-12', name:'General Grievous', artist:null},
      {n:'DV-13', name:'Grand Admiral Thrawn', artist:null},
      {n:'DV-14', name:'Hera Syndulla', artist:null},
      {n:'DV-15', name:'Kit Fisto', artist:null},
      {n:'DV-16', name:'Mace Windu', artist:null},
      {n:'DV-17', name:'Darth Maul', artist:null},
      {n:'DV-18', name:'Obi-Wan Kenobi', artist:null},
      {n:'DV-19', name:'Padmé Amidala', artist:null},
      {n:'DV-20', name:'Plo Koon', artist:null},
      {n:'DV-21', name:'Professor Huyang', artist:null},
      {n:'DV-22', name:'Sabine Wren', artist:null},
      {n:'DV-23', name:'Saw Gerrera', artist:null},
      {n:'DV-24', name:'The Grand Inquisitor', artist:null},
      {n:'DV-25', name:'Yoda', artist:null},
    ]
  },
  {
    id: 'autograph-cards', type: 'auto', title: 'AUTOGRAPH CARDS — 122 CARDS',
    parallels: [{id:'kamino-purple-refractor',name:'Kamino Purple Refractor',print_run:199,color:'#bb8ce4'},{id:'skywalker-blue-refractor',name:'Skywalker Blue Refractor',print_run:150,color:'#7ba2ff'},{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},{id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'A-SLKR', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'A-AA', name:'Bix Caleen', artist:null},
      {n:'A-AW', name:'Mortis Daughter', artist:null},
      {n:'A-AB', name:'Kelleran Beq', artist:null},
      {n:'A-ABE', name:'Jar Jar Binks', artist:null},
      {n:'A-AF', name:'Sergeant Linus Mosk', artist:null},
      {n:'A-AL', name:'Karis Nemik', artist:null},
      {n:'A-AP', name:'General Draven', artist:null},
      {n:'A-AM', name:'Aayla Secura', artist:null},
      {n:'A-SE', name:'Peli Motto', artist:null},
      {n:'A-ASE', name:'Kino Loy', artist:null},
      {n:'A-SLS', name:'Supreme Leader Snoke', artist:null},
      {n:'A-AN', name:'Bazine Netal', artist:null},
      {n:'A-AD', name:'C-3PO', artist:null},
      {n:'A-LE', name:'Major Partagaz', artist:null},
      {n:'A-AV', name:'Kassa', artist:null},
      {n:'A-BL', name:'Kaydel Connix', artist:null},
      {n:'A-BDW', name:'Lando Calrissian', artist:null},
      {n:'A-BLA', name:'Beru Lars', artist:null},
      {n:'A-CJ', name:'Gorian Shard', artist:null},
      {n:'A-CAM', name:'Indara', artist:null},
      {n:'A-CH', name:'Yord Fandar', artist:null},
      {n:'A-CBA', name:'C1-D1', artist:null},
      {n:'A-CB', name:'Klothow', artist:null},
      {n:'A-DK', name:'Jecki Lon', artist:null},
      {n:'A-DR', name:'Rey', artist:null},
      {n:'A-DCA', name:'B2EMO', artist:null},
      {n:'A-DB', name:'Jabba The Hutt', artist:null},
      {n:'A-DCC', name:'Torbin', artist:null},
      {n:'A-DER', name:'Droopy McCool', artist:null},
      {n:'A-DGO', name:'Dedra Meero', artist:null},
      {n:'A-DLR', name:'Morgan Elsbeth', artist:null},
      {n:'A-DL', name:'Cassian Andor', artist:null},
      {n:'A-DGR', name:'General Hux', artist:null},
      {n:'A-EE', name:'Ezra Bridger', artist:null},
      {n:'A-ES', name:'The Armorer', artist:null},
      {n:'A-EK', name:'Enfys Nest', artist:null},
      {n:'A-EM', name:'Obi-Wan Kenobi', artist:null},
      {n:'A-FM', name:'Vel Sartha', artist:null},
      {n:'A-FJ', name:'Jyn Erso', artist:null},
      {n:'A-FS', name:'Maarva Andor', artist:null},
      {n:'A-FW', name:'Saw Gerrera', artist:null},
      {n:'A-FT', name:'Captain Brutus', artist:null},
      {n:'A-GB', name:'Clem Andor', artist:null},
      {n:'A-GOR', name:'Mon Mothma', artist:null},
      {n:'A-GE', name:'Moff Gideon', artist:null},
      {n:'A-GH', name:'Grand Moff Tarkin', artist:null},
      {n:'A-GC', name:'Captain Phasma', artist:null},
      {n:'A-HF', name:'Han Solo', artist:null},
      {n:'A-HC', name:'Anakin Skywalker', artist:null},
      {n:'A-IM', name:'Emperor Palpatine', artist:null},
      {n:'A-IW', name:'Vetch', artist:null},
      {n:'A-IS', name:'Shin Hati', artist:null},
      {n:'A-JC', name:'Toro Calican', artist:null},
      {n:'A-JAL', name:'Gunter', artist:null},
      {n:'A-JE', name:'Owen Lars', artist:null},
      {n:'A-JR', name:'Major Bren Derlin', artist:null},
      {n:'A-JS', name:'Kelnacca', artist:null},
      {n:'A-LAW', name:'Jod Na Nawood', artist:null},
      {n:'A-KCS', name:'Rabé', artist:null},
      {n:'A-KS', name:'Bo-Katan Kryze', artist:null},
      {n:'A-KCH', name:'Queen Apailana', artist:null},
      {n:'A-K', name:'Pokkit', artist:null},
      {n:'A-KMT', name:'Rose Tico', artist:null},
      {n:'A-KC', name:'Admiral Piett', artist:null},
      {n:'A-KR', name:'Zorii Bliss', artist:null},
      {n:'A-KOB', name:'Pegla', artist:null},
      {n:'A-LM', name:'Grand Admiral Thrawn', artist:null},
      {n:'A-LD', name:'Vice Admiral Holdo', artist:null},
      {n:'A-LJJ', name:'Sol', artist:null},
      {n:'A-LL', name:'Major Vonreg', artist:null},
      {n:'A-LN', name:'Maz Kanata', artist:null},
      {n:'A-MJ', name:'The Stranger', artist:null},
      {n:'A-MVE', name:'Vult Skerris', artist:null},
      {n:'A-MH', name:'Luke Skywalker', artist:null},
      {n:'A-MR', name:'Captain Hayle', artist:null},
      {n:'A-M', name:'Poggle the Lesser', artist:null},
      {n:'A-MEW', name:'Hera Syndulla', artist:null},
      {n:'A-MO', name:'Luminara Unduli', artist:null},
      {n:'A-MW', name:'General Grievous', artist:null},
      {n:'A-MA', name:'Sully Stark', artist:null},
      {n:'A-MSA', name:'Barriss Offee', artist:null},
      {n:'A-MC', name:'Even Piell', artist:null},
      {n:'A-MAG', name:'Omega', artist:null},
      {n:'A-MQ', name:'Nien Nunb', artist:null},
      {n:'A-MNW', name:'Fennec Shand', artist:null},
      {n:'A-MI', name:'Reva', artist:null},
      {n:'A-MB', name:'Wilmon Paak', artist:null},
      {n:'A-NP', name:'Padmé Amidala', artist:null},
      {n:'A-NLB', name:'Sabine Wren', artist:null},
      {n:'A-FRO', name:'SM-33', artist:null},
      {n:'A-AJ', name:'Asajj Ventress', artist:null},
      {n:'A-OSJ', name:'Kawlan Roken', artist:null},
      {n:'A-OS', name:'Shaak Ti', artist:null},
      {n:'A-OI', name:'Poe Dameron', artist:null},
      {n:'A-PB', name:'Greedo', artist:null},
      {n:'A-PD', name:'Marrok', artist:null},
      {n:'A-PP', name:'The Mandalorian', artist:null},
      {n:'A-MWE', name:'Myn Weaver', artist:null},
      {n:'A-PL', name:'Kit Fisto', artist:null},
      {n:'A-RAB', name:'Queen Miraj Scintel', artist:null},
      {n:'A-RCC', name:'Wim', artist:null},
      {n:'A-RP', name:'Darth Maul', artist:null},
      {n:'A-RH', name:'Vernestra Rwoh', artist:null},
      {n:'A-RA', name:'Bodhi Rook', artist:null},
      {n:'A-RTS', name:'Neel', artist:null},
      {n:'A-RD', name:'Ahsoka Tano', artist:null},
      {n:'A-RF', name:'The Grand Inquisitor', artist:null},
      {n:'A-RK', name:'Fourth Sister Inquisitor', artist:null},
      {n:'A-SWIT', name:'Dinghy Driver', artist:null},
      {n:'A-SLJ', name:'Mace Windu', artist:null},
      {n:'A-SP', name:'Unkar Plutt', artist:null},
      {n:'A-SW', name:'Max Rebo', artist:null},
      {n:'A-SI', name:'Breha Organa', artist:null},
      {n:'A-SS', name:'Luthen Rael', artist:null},
      {n:'A-TW', name:'IG-11', artist:null},
      {n:'A-TM', name:'Boba Fett', artist:null},
      {n:'A-TO', name:'Cobb Vanth', artist:null},
      {n:'A-TAD', name:'Wendle', artist:null},
      {n:'A-WD', name:'Wicket W. Warrick', artist:null},
      {n:'A-WE', name:'The Client', artist:null},
      {n:'A-ZV', name:'Xanwan', artist:null},
    ]
  },
  {
    id: 'duo-autographs', type: 'auto', title: 'DUO AUTOGRAPHS — 15 CARDS',
    parallels: [{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'DA-AD', name:'General Hux & Supreme Leader Snoke', artist:null},
      {n:'DA-BD', name:'Kaydel Connix & Beaumont Kin', artist:null},
      {n:'DA-CB', name:'Jecki Lon & Yord Fandar', artist:null},
      {n:'DA-CL', name:'Indara & Sol', artist:null},
      {n:'DA-DSK', name:'Luthen Rael & Cassian Andor', artist:null},
      {n:'DA-EP', name:'The Mandalorian & The Armorer', artist:null},
      {n:'DA-FM', name:'Saw Gerrera & Galen Erso', artist:null},
      {n:'DA-ID', name:'Shin Hati & Morgan Elsbeth', artist:null},
      {n:'DA-JA', name:'Peli Motto & Toro Calican', artist:null},
      {n:'DA-KB', name:'Rose Tico & DJ', artist:null},
      {n:'DA-MJj', name:'Sol & The Stranger', artist:null},
      {n:'DA-NJ', name:'SM-33 & Jod Na Nawood', artist:null},
      {n:'DA-RM', name:'The Stranger & Vernestra Rwoh', artist:null},
      {n:'DA-SD', name:'Unkar Plutt & Rey', artist:null},
      {n:'DA-WG', name:'Moff Gideon & The Client', artist:null},
    ]
  },
  {
    id: 'trio-autographs', type: 'auto', title: 'TRIO AUTOGRAPHS — 11 CARDS',
    parallels: [{id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'TA-CJD', name:'Krrsantan, Garsa Fwip & Twi\'lek Majordomo', artist:null},
      {n:'TA-EMR', name:'Obi-Wan Kenobi, Reva & The Grand Inquisitor', artist:null},
      {n:'TA-ENM', name:'Hera Syndulla, Ezra Bridger & Sabine Wren', artist:null},
      {n:'TA-FVG', name:'Mon Mothma, Vel Sartha & Cinta Kaz', artist:null},
      {n:'TA-FZI', name:'Vetch, Xanwan & Maarva Andor', artist:null},
      {n:'TA-HES', name:'Anakin Skywalker, Mace Windu & Obi-Wan Kenobi', artist:null},
      {n:'TA-JRN', name:'Neel, Jod Na Nawood & SM-33', artist:null},
      {n:'TA-JSM', name:'The Modifier, Fennec Shand & Skad', artist:null},
      {n:'TA-KDA', name:'Sergeant Linus Mosk, Syril Karn & Dedra Meero', artist:null},
      {n:'TA-MDN', name:'Asajj Ventress, Omega & Hunter', artist:null},
      {n:'TA-WTN', name:'Kuill, IG-11 & The Client', artist:null},
    ]
  },
  {
    id: '1975-tribute-autograph-variation', type: 'auto', title: '1975 TRIBUTE AUTOGRAPH VARIATION — 47 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'TV-AB', name:'Jar Jar Binks', artist:null},
      {n:'TV-AD', name:'C-3PO', artist:null},
      {n:'TV-ADR', name:'Supreme Leader Kylo Ren', artist:null},
      {n:'TV-BW', name:'Lando Calrissian', artist:null},
      {n:'TV-CF', name:'Leia Organa', artist:null},
      {n:'TV-DB', name:'Jabba The Hutt', artist:null},
      {n:'TV-DG', name:'Dedra Meero', artist:null},
      {n:'TV-DGL', name:'General Hux', artist:null},
      {n:'TV-DL', name:'Cassian Andor', artist:null},
      {n:'TV-DP', name:'Darth Vader', artist:null},
      {n:'TV-DY', name:'Chirrut Îmwe', artist:null},
      {n:'TV-EE', name:'Ezra Bridger', artist:null},
      {n:'TV-EM', name:'Obi-Wan Kenobi', artist:null},
      {n:'TV-ES', name:'The Armorer', artist:null},
      {n:'TV-FJ', name:'Jyn Erso', artist:null},
      {n:'TV-GC', name:'Captain Phasma', artist:null},
      {n:'TV-GE', name:'Moff Gideon', artist:null},
      {n:'TV-GH', name:'Grand Moff Tarkin', artist:null},
      {n:'TV-GR', name:'Mon Mothma', artist:null},
      {n:'TV-HC', name:'Anakin Skywalker', artist:null},
      {n:'TV-HF', name:'Han Solo', artist:null},
      {n:'TV-IM', name:'Emperor Palpatine', artist:null},
      {n:'TV-IS', name:'Shin Hati', artist:null},
      {n:'TV-JOS', name:'Chewbacca', artist:null},
      {n:'TV-KS', name:'Bo-Katan Kryze', artist:null},
      {n:'TV-LAW', name:'Jod Na Nawood', artist:null},
      {n:'TV-LJ', name:'Sol', artist:null},
      {n:'TV-LM', name:'Grand Admiral Thrawn', artist:null},
      {n:'TV-MEW', name:'Hera Syndulla', artist:null},
      {n:'TV-MH', name:'Luke Skywalker', artist:null},
      {n:'TV-MJ', name:'The Stranger', artist:null},
      {n:'TV-MQ', name:'Nien Nunb', artist:null},
      {n:'TV-MW', name:'General Grievous', artist:null},
      {n:'TV-NB', name:'Sabine Wren', artist:null},
      {n:'TV-NP', name:'Padmé Amidala', artist:null},
      {n:'TV-PB', name:'Greedo', artist:null},
      {n:'TV-PP', name:'The Mandalorian', artist:null},
      {n:'TV-RD', name:'Ahsoka Tano', artist:null},
      {n:'TV-RP', name:'Darth Maul', artist:null},
      {n:'TV-SJ', name:'Mace Windu', artist:null},
      {n:'TV-SP', name:'Unkar Plutt', artist:null},
      {n:'TV-SS', name:'Luthen Rael', artist:null},
      {n:'TV-TM', name:'Boba Fett', artist:null},
      {n:'TV-TR', name:'Admiral Ackbar', artist:null},
      {n:'TV-TW', name:'IG-11', artist:null},
      {n:'TV-WD', name:'Wicket W. Warrick', artist:null},
      {n:'TV-WILL', name:'Max Rebo', artist:null},
    ]
  },
  {
    id: 'sketch-cards', type: 'sketch', title: 'SKETCH CARDS — 188 ARTISTS',
    // Foils (Silver / Gold / Black, each 1/1) are picked per sketch entry via
    // the SketchPanel's default ladder, not modeled as row parallels.
    parallels: [],
    cards: [
      {n:'1', name:'Sketch Card', artist:'Adam Beck'},
      {n:'2', name:'Sketch Card', artist:'Aleksandr Gigov'},
      {n:'3', name:'Sketch Card', artist:'Alex Mines'},
      {n:'4', name:'Sketch Card', artist:'Alexander Diab'},
      {n:'5', name:'Sketch Card', artist:'Allen Grimes'},
      {n:'6', name:'Sketch Card', artist:'Andrew Fry'},
      {n:'7', name:'Sketch Card', artist:'Andy Hanks'},
      {n:'8', name:'Sketch Card', artist:'Angel Aviles'},
      {n:'9', name:'Sketch Card', artist:'Angelina Benedetti'},
      {n:'10', name:'Sketch Card', artist:'Anthony Pietszak'},
      {n:'11', name:'Sketch Card', artist:'Antni Ellison'},
      {n:'12', name:'Sketch Card', artist:'Ari Arnaldsson'},
      {n:'13', name:'Sketch Card', artist:'Ashley Marsh'},
      {n:'14', name:'Sketch Card', artist:'Basak Kahraman'},
      {n:'15', name:'Sketch Card', artist:'Ben Jones'},
      {n:'16', name:'Sketch Card', artist:'Bistek Javier'},
      {n:'17', name:'Sketch Card', artist:'Bobby Blakey'},
      {n:'18', name:'Sketch Card', artist:'Brandon "B.Done" Blevins'},
      {n:'19', name:'Sketch Card', artist:'Brandon Klein'},
      {n:'20', name:'Sketch Card', artist:'Brent Ragland'},
      {n:'21', name:'Sketch Card', artist:'C DUB'},
      {n:'22', name:'Sketch Card', artist:'Candice Clemmons'},
      {n:'23', name:'Sketch Card', artist:'Charlie Cody'},
      {n:'24', name:'Sketch Card', artist:'Chris Meeks'},
      {n:'25', name:'Sketch Card', artist:'Chris Thorne'},
      {n:'26', name:'Sketch Card', artist:'Cisco Rivera'},
      {n:'27', name:'Sketch Card', artist:'Cyrus Sherkat'},
      {n:'28', name:'Sketch Card', artist:'Dan Bergren'},
      {n:'29', name:'Sketch Card', artist:'Dan Cooney'},
      {n:'30', name:'Sketch Card', artist:'Dan Curto'},
      {n:'31', name:'Sketch Card', artist:'Dan Gorman'},
      {n:'32', name:'Sketch Card', artist:'Dan Lawler'},
      {n:'33', name:'Sketch Card', artist:'Dan Tearle'},
      {n:'34', name:'Sketch Card', artist:'Daniel Chavez'},
      {n:'35', name:'Sketch Card', artist:'Daniel Riveron'},
      {n:'36', name:'Sketch Card', artist:'Darrin Pepe'},
      {n:'37', name:'Sketch Card', artist:'Dave Fowler'},
      {n:'38', name:'Sketch Card', artist:'Dave Gaskin'},
      {n:'39', name:'Sketch Card', artist:'David "Dove" McHargue'},
      {n:'40', name:'Sketch Card', artist:'David Willingham'},
      {n:'41', name:'Sketch Card', artist:'Dawn Murphy'},
      {n:'42', name:'Sketch Card', artist:'Don Pedicini Jr'},
      {n:'43', name:'Sketch Card', artist:'Douglas Stromenger'},
      {n:'44', name:'Sketch Card', artist:'Dwayne Carpenter'},
      {n:'45', name:'Sketch Card', artist:'Dylan Riley'},
      {n:'46', name:'Sketch Card', artist:'El Smetchö'},
      {n:'47', name:'Sketch Card', artist:'Elvin A Hernandez'},
      {n:'48', name:'Sketch Card', artist:'Emma Douglas'},
      {n:'49', name:'Sketch Card', artist:'Emrah Cildir'},
      {n:'50', name:'Sketch Card', artist:'Emre Varlıbaş'},
      {n:'51', name:'Sketch Card', artist:'Eric Lehtonen'},
      {n:'52', name:'Sketch Card', artist:'Eric Medina'},
      {n:'53', name:'Sketch Card', artist:'Erik Muller'},
      {n:'54', name:'Sketch Card', artist:'Evgheni Batu'},
      {n:'55', name:'Sketch Card', artist:'Frank A. Kadar'},
      {n:'56', name:'Sketch Card', artist:'Frank Sansone'},
      {n:'57', name:'Sketch Card', artist:'Franklim Teixeira'},
      {n:'58', name:'Sketch Card', artist:'Gabe Farber'},
      {n:'59', name:'Sketch Card', artist:'Gerry Garcia Jr'},
      {n:'60', name:'Sketch Card', artist:'Greg Treize'},
      {n:'61', name:'Sketch Card', artist:'Guilherme Rocha'},
      {n:'62', name:'Sketch Card', artist:'Ian McKesson'},
      {n:'63', name:'Sketch Card', artist:'Isiah Xavier Bradley'},
      {n:'64', name:'Sketch Card', artist:'J. Hammond'},
      {n:'65', name:'Sketch Card', artist:'Jaime Lopez'},
      {n:'66', name:'Sketch Card', artist:'Jake Minor'},
      {n:'67', name:'Sketch Card', artist:'James Boyd'},
      {n:'68', name:'Sketch Card', artist:'James Harris'},
      {n:'69', name:'Sketch Card', artist:'Jamie Richards'},
      {n:'70', name:'Sketch Card', artist:'Jamison Murdock'},
      {n:'71', name:'Sketch Card', artist:'Jason Adams'},
      {n:'72', name:'Sketch Card', artist:'Jason Christner'},
      {n:'73', name:'Sketch Card', artist:'Jason Davies'},
      {n:'74', name:'Sketch Card', artist:'Jason Montoya'},
      {n:'75', name:'Sketch Card', artist:'Jason Queen'},
      {n:'76', name:'Sketch Card', artist:'Jason Saldajeno'},
      {n:'77', name:'Sketch Card', artist:'Jason Sobol'},
      {n:'78', name:'Sketch Card', artist:'Jay Manchand'},
      {n:'79', name:'Sketch Card', artist:'Jeffrey C. Benitez'},
      {n:'80', name:'Sketch Card', artist:'Jenna McGrath'},
      {n:'81', name:'Sketch Card', artist:'Jessica Hickman'},
      {n:'82', name:'Sketch Card', artist:'Jessica Van Dusen'},
      {n:'83', name:'Sketch Card', artist:'Jim O\'Riley'},
      {n:'84', name:'Sketch Card', artist:'Joe Ortiz'},
      {n:'85', name:'Sketch Card', artist:'Joey Mason'},
      {n:'86', name:'Sketch Card', artist:'John "JAR" Rodriguez'},
      {n:'87', name:'Sketch Card', artist:'John Bruce'},
      {n:'88', name:'Sketch Card', artist:'John Pleak'},
      {n:'89', name:'Sketch Card', artist:'John Still'},
      {n:'90', name:'Sketch Card', artist:'Jonathan Beistline'},
      {n:'91', name:'Sketch Card', artist:'Josh Trout'},
      {n:'92', name:'Sketch Card', artist:'Jude Gallagher'},
      {n:'93', name:'Sketch Card', artist:'Julia McKenzie'},
      {n:'94', name:'Sketch Card', artist:'Julie-Anne'},
      {n:'95', name:'Sketch Card', artist:'Justin Bruce Lee'},
      {n:'96', name:'Sketch Card', artist:'Kang Jing'},
      {n:'97', name:'Sketch Card', artist:'Karl Jones'},
      {n:'98', name:'Sketch Card', artist:'Kevin Cleveland'},
      {n:'99', name:'Sketch Card', artist:'Kevin Graham'},
      {n:'100', name:'Sketch Card', artist:'Kevin P. West'},
      {n:'101', name:'Sketch Card', artist:'Kevin Scott Jacobs'},
      {n:'102', name:'Sketch Card', artist:'Khloe Delnick'},
      {n:'103', name:'Sketch Card', artist:'Khushi Mahajan'},
      {n:'104', name:'Sketch Card', artist:'Kirk Chavarria'},
      {n:'105', name:'Sketch Card', artist:'Kris Penix'},
      {n:'106', name:'Sketch Card', artist:'Krishna Sharma'},
      {n:'107', name:'Sketch Card', artist:'Kyle Babbitt'},
      {n:'108', name:'Sketch Card', artist:'Lee Lightfoot'},
      {n:'109', name:'Sketch Card', artist:'Limuel Pinzon'},
      {n:'110', name:'Sketch Card', artist:'Lindsey Greyling'},
      {n:'111', name:'Sketch Card', artist:'Loc Nguyen'},
      {n:'112', name:'Sketch Card', artist:'Lukas Maurer'},
      {n:'113', name:'Sketch Card', artist:'Luke Seavers'},
      {n:'114', name:'Sketch Card', artist:'Madison Emerick'},
      {n:'115', name:'Sketch Card', artist:'Marcia Dye'},
      {n:'116', name:'Sketch Card', artist:'Mark Stroud'},
      {n:'117', name:'Sketch Card', artist:'Marlo Agunos'},
      {n:'118', name:'Sketch Card', artist:'Mathilde Machuel'},
      {n:'119', name:'Sketch Card', artist:'Matt Maldonado'},
      {n:'120', name:'Sketch Card', artist:'Matt Steffens'},
      {n:'121', name:'Sketch Card', artist:'Matt Stewart'},
      {n:'122', name:'Sketch Card', artist:'Matthew Skillern'},
      {n:'123', name:'Sketch Card', artist:'Matthew Sutton'},
      {n:'124', name:'Sketch Card', artist:'Mayumi Seto'},
      {n:'125', name:'Sketch Card', artist:'Michael Mastermaker'},
      {n:'126', name:'Sketch Card', artist:'Michael Munshaw'},
      {n:'127', name:'Sketch Card', artist:'Michael W. Foreman II'},
      {n:'128', name:'Sketch Card', artist:'Mike Dalzell'},
      {n:'129', name:'Sketch Card', artist:'Mike Davidson'},
      {n:'130', name:'Sketch Card', artist:'Mike J Sealie'},
      {n:'131', name:'Sketch Card', artist:'Mike LaPeruta'},
      {n:'132', name:'Sketch Card', artist:'Mike Stephens'},
      {n:'133', name:'Sketch Card', artist:'Nathaniel Howard'},
      {n:'134', name:'Sketch Card', artist:'Neil A Brady'},
      {n:'135', name:'Sketch Card', artist:'Neil Camera'},
      {n:'136', name:'Sketch Card', artist:'Nick Gribbon'},
      {n:'137', name:'Sketch Card', artist:'Oscar Chavez'},
      {n:'138', name:'Sketch Card', artist:'Patricio Carrasco'},
      {n:'139', name:'Sketch Card', artist:'Phillip Trujillo'},
      {n:'140', name:'Sketch Card', artist:'Quinton Baker'},
      {n:'141', name:'Sketch Card', artist:'Rachel Jane Hetherington'},
      {n:'142', name:'Sketch Card', artist:'Rebeca Louro'},
      {n:'143', name:'Sketch Card', artist:'Rees Chua-Finlay'},
      {n:'144', name:'Sketch Card', artist:'Rich "RAM" Molinelli'},
      {n:'145', name:'Sketch Card', artist:'Rich Hennemann'},
      {n:'146', name:'Sketch Card', artist:'Rico Dela Rosa'},
      {n:'147', name:'Sketch Card', artist:'Rob Demers'},
      {n:'148', name:'Sketch Card', artist:'Robert Hendrickson'},
      {n:'149', name:'Sketch Card', artist:'Rugved Bhuskute'},
      {n:'150', name:'Sketch Card', artist:'Rustico Limosinero'},
      {n:'151', name:'Sketch Card', artist:'Rusty Gilligan'},
      {n:'152', name:'Sketch Card', artist:'Rutvig Vaid'},
      {n:'153', name:'Sketch Card', artist:'Ryan Crosby'},
      {n:'154', name:'Sketch Card', artist:'Ryan Edwards'},
      {n:'155', name:'Sketch Card', artist:'Ryan Finley'},
      {n:'156', name:'Sketch Card', artist:'Ryan Johnston'},
      {n:'157', name:'Sketch Card', artist:'Ryan Olsen'},
      {n:'158', name:'Sketch Card', artist:'Ryan Thompson'},
      {n:'159', name:'Sketch Card', artist:'Sammy Gomez'},
      {n:'160', name:'Sketch Card', artist:'Scott Anthony'},
      {n:'161', name:'Sketch Card', artist:'Scott Houseman'},
      {n:'162', name:'Sketch Card', artist:'Scott West'},
      {n:'163', name:'Sketch Card', artist:'Scott Zenteno'},
      {n:'164', name:'Sketch Card', artist:'Sean Earey'},
      {n:'165', name:'Sketch Card', artist:'Sean Mathews'},
      {n:'166', name:'Sketch Card', artist:'Semra Bulut'},
      {n:'167', name:'Sketch Card', artist:'Shaow Siong'},
      {n:'168', name:'Sketch Card', artist:'Shyla Lee'},
      {n:'169', name:'Sketch Card', artist:'Sir Edmund Duke'},
      {n:'170', name:'Sketch Card', artist:'Stax'},
      {n:'171', name:'Sketch Card', artist:'Stephane Leonardi'},
      {n:'172', name:'Sketch Card', artist:'Stephanie Swanger'},
      {n:'173', name:'Sketch Card', artist:'Steve Alce'},
      {n:'174', name:'Sketch Card', artist:'Taylor Chojecki'},
      {n:'175', name:'Sketch Card', artist:'Ted Dastick Jr'},
      {n:'176', name:'Sketch Card', artist:'Todd Aaron Smith'},
      {n:'177', name:'Sketch Card', artist:'Tom Amici'},
      {n:'178', name:'Sketch Card', artist:'Tomoko Taniguchi'},
      {n:'179', name:'Sketch Card', artist:'Tony Riley'},
      {n:'180', name:'Sketch Card', artist:'Traci Easterday'},
      {n:'181', name:'Sketch Card', artist:'Trent Westbrook'},
      {n:'182', name:'Sketch Card', artist:'Veronica Louro'},
      {n:'183', name:'Sketch Card', artist:'Veronica Smith'},
      {n:'184', name:'Sketch Card', artist:'Vincenzo "Chenduz" D\'Ippolito'},
      {n:'185', name:'Sketch Card', artist:'Vini Pirani'},
      {n:'186', name:'Sketch Card', artist:'Ward Silverman'},
      {n:'187', name:'Sketch Card', artist:'Will Pleydon'},
      {n:'188', name:'Sketch Card', artist:'Zach Woolsey'},
    ]
  },
];

export const PARALLELS = [
  {id:'prism-refractor',name:'Prism Refractor',print_run:null,color:'#d4d1e8'},
  {id:'raywave-refractor',name:'RayWave Refractor',print_run:null,color:'#6cef4d'},
  {id:'blue-pulsar-refractor',name:'Blue Pulsar Refractor',print_run:null,color:'#5f8dff'},
  {id:'purple-pulsar-refractor',name:'Purple Pulsar Refractor',print_run:null,color:'#cb7dff'},
  {id:'black-and-white-shimmer-refractor',name:'Black & White Shimmer Refractor',print_run:null,color:'#e8e8ec'},
  {id:'kamino-purple-refractor',name:'Kamino Purple Refractor',print_run:199,color:'#bb8ce4'},
  {id:'skywalker-blue-refractor',name:'Skywalker Blue Refractor',print_run:150,color:'#7ba2ff'},
  {id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},
  {id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},
  {id:'gold-mini-diamonds-refractor',name:'Gold Mini Diamonds Refractor',print_run:50,color:'#f3d985'},
  {id:'orange-pulsar-refractor',name:'Orange Pulsar Refractor',print_run:25,color:'#ff9d52'},
  {id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},
  {id:'black-pulsar-refractor',name:'Black Pulsar Refractor',print_run:10,color:'#a8a8b4'},
  {id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},
  {id:'mustafar-black-lava-refractor',name:'Mustafar Black Lava Refractor',print_run:10,color:'#c98f82'},
  {id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},
  {id:'red-pulsar-refractor',name:'Red Pulsar Refractor',print_run:5,color:'#ff806b'},
  {id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'},
  {id:'rebel-orange-wave-refractor',name:'Rebel Orange Wave Refractor',print_run:25,color:'#ffb072'},
  {id:'dathomir-red-wave-refractor',name:'Dathomir Red Wave Refractor',print_run:5,color:'#ff9090'},
  {id:'rainbow-refractor',name:'Rainbow Refractor',print_run:null,color:'#e7c3e2'},
];

export const AUTO_PARALLELS = [
  {id:'kamino-purple-refractor',name:'Kamino Purple Refractor',print_run:199,color:'#bb8ce4'},
  {id:'skywalker-blue-refractor',name:'Skywalker Blue Refractor',print_run:150,color:'#7ba2ff'},
  {id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},
  {id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},
  {id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},
  {id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},
  {id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},
  {id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'},
];

export const INSERT_PARALLELS = [
  {id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},
  {id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},
  {id:'rebel-orange-refractor',name:'Rebel Orange Refractor',print_run:25,color:'#ff8a3d'},
  {id:'mustafar-black-refractor',name:'Mustafar Black Refractor',print_run:10,color:'#9c9c96'},
  {id:'dathomir-red-refractor',name:'Dathomir Red Refractor',print_run:5,color:'#ff5d5d'},
  {id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'},
];
